import CanvasContainer from "../../canvas/CanvasContainer.tsx";
import "leaflet-draw";
import "leaflet-draw/dist/leaflet.draw.css";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import html2canvas from "html2canvas";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import jsPDF from "jspdf";
import { useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckIcon from "@mui/icons-material/Check";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import RedoOutlinedIcon from "@mui/icons-material/RedoOutlined";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import IosShareOutlinedIcon from "@mui/icons-material/IosShareOutlined";
import SlideshowOutlinedIcon from "@mui/icons-material/SlideshowOutlined";
import TextFieldsOutlinedIcon from "@mui/icons-material/TextFieldsOutlined";
import ThreeDRotationOutlinedIcon from "@mui/icons-material/ThreeDRotationOutlined";
import UndoOutlinedIcon from "@mui/icons-material/UndoOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VideoLibraryOutlinedIcon from "@mui/icons-material/VideoLibraryOutlined";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import { openAppConfirm } from "../../components/AppDialogs";
import SharePresentationDialog from "./SharePresentationDialog";
import SlideMiniPreview from "./SlideMiniPreview";
import { getSlideElements } from "./presentationPreview";
import { isPowerPointFile, parsePptxFile, PptxImportError } from "./pptxImport";
import { allowCanvasFont } from "../../canvas/Components/TextElement.tsx";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import SearchIcon from "@mui/icons-material/Search";
import ImageIcon from "@mui/icons-material/ImageOutlined";
import MovieIcon from "@mui/icons-material/MovieOutlined";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import bgAurora from "../../assets/presntationBG/bg-aurora.svg";
import bgEmeraldBands from "../../assets/presntationBG/bg-emerald-bands.svg";
import bgGrid from "../../assets/presntationBG/bg-grid.svg";
import bgLilacOrbit from "../../assets/presntationBG/bg-lilac-orbit.svg";
import bgMidnightFrame from "../../assets/presntationBG/bg-midnight-frame.svg";
import bgMintPaper from "../../assets/presntationBG/bg-mint-paper.svg";
import bgNavyBeams from "../../assets/presntationBG/bg-navy-beams.svg";
import bgObsidianGrid from "../../assets/presntationBG/bg-obsidian-grid.svg";
import bgSandTiles from "../../assets/presntationBG/bg-sand-tiles.svg";
import bgSkyCurves from "../../assets/presntationBG/bg-sky-curves.svg";
import bgSlateRings from "../../assets/presntationBG/bg-slate-rings.svg";
import bgSoftBlueRibbon from "../../assets/presntationBG/bg-soft-blue-ribbon.svg";
import bgTealGlow from "../../assets/presntationBG/bg-teal-glow.svg";
import bgWaves from "../../assets/presntationBG/bg-waves.svg";
import "./map.css";
import "./presentationMaker.css";
import {
  AddSlideToPresentationCall,
  GetAllSlideWithContentByTitleId,
  AddContentToSlidePresentationCall,
  EditContentToSlidePresentationCall,
  DeletePresentationSlideCall,
} from "../../redux/api/universities.api.js";
import { CallAPI } from "../../apiManager/ApiCall";
import { getAddSlidePresentationURL } from "../../apiManager/APIConfig";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { store } from "../../redux/store.js";
import { useDispatch, useSelector } from "react-redux";
import {
  setSlides,
  setCurrentSlide,
  updateCurrentSlideContent,
  updateSlideContentById,
} from "../../redux/slices/uniSlice";
import {
  GetTitlesCall,
  UpdatePresentationPublishCall,
  EditSubTitlesCall,
} from "../../redux/api/title.api";
import MDButton from "components/MDButton";
import {
  GetMyUploadsCall,
  UploadMyFileCall,
  UploadMyFileRecordCall,
  DeleteMyUploadCall,
  getPersistedUploads,
  persistUploads,
} from "../../redux/api/uploads.api";
import {
  ConfirmMyPresentationImageCall,
  DescribeMyPresentationImageCall,
  GenerateTeachingImageCall,
  GetMyPresentationImagesCall,
  RegenerateMyPresentationImageCall,
} from "../../redux/api/presentationImages.api";
import ImageSourcePicker from "./ImageSourcePicker";
import DesignStudio from "./cinema/DesignStudio";
import WorkspaceStage, { WorkspaceOverlay } from "./WorkspaceStage";
import CinematicPlayer from "./cinema/CinematicPlayer";
import {
  DEFAULT_TRANSITION,
  getRenderableElements,
  getSlideDesign,
  withSlideDesign,
} from "../../canvas/design/slideDesign";
import {
  ensureThemeFonts,
  getTheme,
  restyleTextHtml,
  textRole,
  themedTextHtml,
} from "../../canvas/design/themes";
import { getBackgroundPreset } from "../../canvas/design/backgrounds";
import { TRANSITIONS } from "../../canvas/design/transitions";
import { matchMorphElements } from "../../canvas/design/morph";
import { previewAnimationsOnCanvas } from "../../canvas/design/elementAnimations";
import { parseDesignRequest } from "../../canvas/design/designIntent";
import { PRESENTATION_DESIGN_EVENT } from "../../components/AIAssistant/drafts/presentationDesignBridge";
import {
  getPreferOwnImages,
  getPresentationImageSource,
  setPreferOwnImages,
  setPresentationImageSource,
  subscribePresentationImageSource,
} from "./imageSourcePreference";

const PRESENTATION_RELOAD_KEY = "presentation-maker-auto-play";

const DESIGN_CHAT_OPTIONS = [
  { id: "design_undo", label: "Undo", prompt: "Undo the design change" },
  { id: "design_preview", label: "Preview", prompt: "Preview the presentation" },
];

const stripLegacyBackground = (data) =>
  (Array.isArray(data) ? data : []).filter((el) => !(el?.type === "IMAGE" && el?.isBackground));

const plainTextOf = (html) =>
  String(html || "")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

/** Elements an "animate the labels / text / images" request should build. */
const pickAnimationTargets = (data, target) => {
  const els = getRenderableElements(data).filter((el) => el?.id && !el.isBackground);
  const isLabel = (el) =>
    el.type === "TEXT" &&
    (textRole(el.content) === "body" || plainTextOf(el.content).length <= 40) &&
    textRole(el.content) !== "heading";
  const picked =
    target === "labels"
      ? els.filter(isLabel)
      : target === "text"
        ? els.filter((el) => el.type === "TEXT")
        : target === "images"
          ? els.filter((el) => el.type !== "TEXT")
          : els;
  return picked.sort(
    (a, b) =>
      (Number(a.position?.top) || 0) - (Number(b.position?.top) || 0) ||
      (Number(a.position?.left) || 0) - (Number(b.position?.left) || 0)
  );
};
const PPTX_SCRIPT_ID = "pptxgenjs-browser-script";


let pptxScriptPromise = null;

const loadPptxGenJS = () => {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("PptxGenJS can only load in the browser"));
  }
  if (window.PptxGenJS) {
    return Promise.resolve(window.PptxGenJS);
  }
  if (pptxScriptPromise) {
    return pptxScriptPromise;
  }

  pptxScriptPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(PPTX_SCRIPT_ID);
    if (existingScript) {
      existingScript.addEventListener("load", () => resolve(window.PptxGenJS), { once: true });
      existingScript.addEventListener(
        "error",
        () => reject(new Error("Failed to load PowerPoint export library")),
        { once: true }
      );
      return;
    }

    const script = document.createElement("script");
    script.id = PPTX_SCRIPT_ID;
    script.src = "https://cdn.jsdelivr.net/npm/pptxgenjs@4.0.1/dist/pptxgen.min.js";
    script.async = true;
    script.onload = () => resolve(window.PptxGenJS);
    script.onerror = () => reject(new Error("Failed to load PowerPoint export library"));
    document.body.appendChild(script);
  });

  return pptxScriptPromise;
};

function PresentationMakerPage() {
  const cloneCanvasData = useCallback((data) => {
    if (!Array.isArray(data)) return [];
    try {
      return JSON.parse(JSON.stringify(data));
    } catch (error) {
      return data.map((item) => ({ ...item }));
    }
  }, []);

  const { t } = useTranslation();
  const theme = useTheme();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const allSlides = useSelector((state) => state.uni?.slides);
  const allTitles = useSelector((state) => {
    const st = state.title;
    if (!st) return [];
    return Array.isArray(st.titles) ? st.titles : [];
  });
  const currentLang = useSelector((state) => state.general?.lang || "en");
  const university = useSelector((state) => state.auth?.universityInfo);
  const isDark = theme.palette.mode === "dark";
  const currentSlide = useSelector((state) => state.uni?.currentSlide);
  const toolbarActionsRef = useRef(null);
  const stageAreaRef = useRef(null);
  const editStageFrameRef = useRef(null);
  const initialCanvasData = currentSlide?.content?.data
    ? (Array.isArray(currentSlide.content.data) ? currentSlide.content.data : [])
    : [];
  const WEB_EDIT_STAGE_WIDTH = 1280;
  const WEB_EDIT_STAGE_HEIGHT = 720;
  const MOBILE_EDIT_STAGE_WIDTH = 414;
  const MOBILE_EDIT_STAGE_HEIGHT = 800;
  const PLAY_STAGE_WIDTH = 1280;
  const PLAY_STAGE_HEIGHT = 720;
  const FRAME_BORDER_SIZE = 16;
  const EXPORT_STAGE_WIDTH = PLAY_STAGE_WIDTH + FRAME_BORDER_SIZE;
  const EXPORT_STAGE_HEIGHT = PLAY_STAGE_HEIGHT + FRAME_BORDER_SIZE;
  // Clamp displayed stage size so layout stays consistent on very small or very large screens
  const MAX_STAGE_DISPLAY_WIDTH = 1600;
  const MAX_STAGE_DISPLAY_HEIGHT = 900;
  const latestSaveRequestRef = useRef(0);
  const latestCanvasSnapshotRef = useRef([]);
  const exportStageRef = useRef(null);

  const hasValidId = id && id !== "undefined";
  const [initialLoadDone, setInitialLoadDone] = useState(false);
  const hasEnsuredSlideRef = useRef(false);
  const [fileMenuAnchor, setFileMenuAnchor] = useState(null);
  const [shareOpen, setShareOpen] = useState(false);
  const [publishMenuAnchor, setPublishMenuAnchor] = useState(null);
  const [publishStatus, setPublishStatus] = useState("unpublished");
  const [editScale, setEditScale] = useState(1);
  const [viewMode, setViewMode] = useState("web"); // "web" | "mobile"
  const EDIT_STAGE_WIDTH =
    viewMode === "mobile" ? MOBILE_EDIT_STAGE_WIDTH : WEB_EDIT_STAGE_WIDTH;
  const EDIT_STAGE_HEIGHT =
    viewMode === "mobile" ? MOBILE_EDIT_STAGE_HEIGHT : WEB_EDIT_STAGE_HEIGHT;
  const editStageFrameW = EDIT_STAGE_WIDTH + FRAME_BORDER_SIZE;
  const editStageFrameH = EDIT_STAGE_HEIGHT + FRAME_BORDER_SIZE;
  const [activePanel, setActivePanel] = useState(null);
  // Cinematic design studio (right panel) + deck-wide design undo/redo.
  const [studioOpen, setStudioOpen] = useState(false);
  const [studioTab, setStudioTab] = useState("design");
  const deckUndoRef = useRef([]);
  const deckRedoRef = useRef([]);
  const [, setDeckHistoryVersion] = useState(0);
  const [designToast, setDesignToast] = useState(null);
  const [isExporting, setIsExporting] = useState(false);
  const [exportSlidePayload, setExportSlidePayload] = useState(null);
  const [exportSlideKey, setExportSlideKey] = useState("export-slide");
  const backgroundOptions = useMemo(
    () => [
      { key: "aurora", labelKey: "pages.presentationMaker.aurora", src: bgAurora },
      { key: "soft-blue-ribbon", labelKey: "pages.presentationMaker.softBlueRibbon", src: bgSoftBlueRibbon },
      { key: "sky-curves", labelKey: "pages.presentationMaker.skyCurves", src: bgSkyCurves },
      { key: "grid", labelKey: "pages.presentationMaker.grid", src: bgGrid },
      { key: "mint-paper", labelKey: "pages.presentationMaker.mintPaper", src: bgMintPaper },
      { key: "sand-tiles", labelKey: "pages.presentationMaker.sandTiles", src: bgSandTiles },
      { key: "lilac-orbit", labelKey: "pages.presentationMaker.lilacOrbit", src: bgLilacOrbit },
      { key: "waves", labelKey: "pages.presentationMaker.waves", src: bgWaves },
      { key: "midnight-frame", labelKey: "pages.presentationMaker.midnightFrame", src: bgMidnightFrame },
      { key: "slate-rings", labelKey: "pages.presentationMaker.slateRings", src: bgSlateRings },
      { key: "navy-beams", labelKey: "pages.presentationMaker.navyBeams", src: bgNavyBeams },
      { key: "obsidian-grid", labelKey: "pages.presentationMaker.obsidianGrid", src: bgObsidianGrid },
      { key: "teal-glow", labelKey: "pages.presentationMaker.tealGlow", src: bgTealGlow },
      { key: "emerald-bands", labelKey: "pages.presentationMaker.emeraldBands", src: bgEmeraldBands },
    ],
    []
  );
  const backgroundColorOptions = useMemo(
    () => [
      "#FFFFFF",
      "#F8FAFC",
      "#E0F2FE",
      "#DBEAFE",
      "#EDE9FE",
      "#ECFDF5",
      "#FEF3C7",
      "#FEE2E2",
      "#0F172A",
      "#111827",
    ],
    []
  );

  const classicBackgrounds = useMemo(
    () => backgroundOptions.map((bg) => ({ key: bg.key, label: t(bg.labelKey), src: bg.src })),
    [backgroundOptions, t]
  );

  // Uploads side-panel state (private media library)
  const [uploadsTab, setUploadsTab] = useState("images");
  const [uploads, setUploads] = useState([]);
  const [uploadsLoading, setUploadsLoading] = useState(false);
  const [uploadsUploading, setUploadsUploading] = useState(false);
  const [uploadsSearch, setUploadsSearch] = useState("");
  const [imageSource, setImageSource] = useState(getPresentationImageSource);
  const [preferOwnImages, setPreferOwnImagesState] = useState(getPreferOwnImages);
  const [imagePrompt, setImagePrompt] = useState("");
  const userRole = useSelector((state) => state.auth?.role);
  const [imageReview, setImageReview] = useState(null);
  const [imageProgress, setImageProgress] = useState(0);
  const [imageLibrary, setImageLibrary] = useState([]);
  const makingImage = imageReview?.phase === "generating" && !imageReview?.fileId;
  useEffect(() => {
    if (!makingImage) return undefined;
    setImageProgress(6);
    const started = Date.now();
    const timer = window.setInterval(() => {
      const elapsed = Date.now() - started;
      const next = Math.min(92, 6 + (1 - Math.exp(-elapsed / 18000)) * 86);
      setImageProgress(next);
    }, 350);
    return () => window.clearInterval(timer);
  }, [makingImage]);

  const uploadsInputRef = useRef(null);
  const pptxInputRef = useRef(null);
  const pptImportingRef = useRef(false);
  const [pptImport, setPptImport] = useState(null);
  const [draggedSlideId, setDraggedSlideId] = useState(null);

  // Ensure presentation titles are in Redux so we can resolve publish state from is_published
  useEffect(() => {
    GetTitlesCall(currentLang, "presentation");
  }, [currentLang]);

  // When slides are loaded again, keep the open slide on the object from that
  // list. Leaving the editor and coming back used to keep the previous
  // in-memory slide (same id, old positions) because the canvas only reads
  // its data once. Thumbnail clicks already pass the loaded slide, which is
  // why changing slides put everything back.
  useEffect(() => {
    if (!Array.isArray(allSlides) || allSlides.length === 0) {
      if (currentSlide) {
        dispatch(setCurrentSlide(null));
      }
      return;
    }
    const fresh = currentSlide
      ? allSlides.find((s) => String(s.id) === String(currentSlide.id))
      : null;
    if (!fresh) {
      dispatch(setCurrentSlide(allSlides[0]));
      return;
    }
    if (fresh === currentSlide) return;
    let sameContent = false;
    try {
      sameContent =
        JSON.stringify(fresh.content?.data ?? []) ===
        JSON.stringify(currentSlide?.content?.data ?? []);
    } catch (error) {
      sameContent = false;
    }
    if (!sameContent) {
      dispatch(setCurrentSlide(fresh));
    }
  }, [allSlides, currentSlide, dispatch]);

  // Find the specific presentation subtitle (session) by route param id
  const presentationSubtitle = useMemo(() => {
    if (!id || !Array.isArray(allTitles)) return null;
    for (const t of allTitles) {
      if (Array.isArray(t.subtitles)) {
        const sub = t.subtitles.find((s) => String(s.id) === String(id));
        if (sub) return sub;
      }
    }
    return null;
  }, [allTitles, id]);

  const presentationInternalName = useMemo(() => {
    const locs = presentationSubtitle?.titleLocalizations;
    if (!Array.isArray(locs)) return t("pages.presentationTitles.untitledPresentation");
    const titleLoc = locs.find((e) => e.field === "title");
    return (
      String(titleLoc?.value || "").trim() ||
      t("pages.presentationTitles.untitledPresentation")
    );
  }, [presentationSubtitle, t]);

  const [editingPresentationName, setEditingPresentationName] = useState(false);
  const [presentationNameDraft, setPresentationNameDraft] = useState("");

  useEffect(() => {
    if (!editingPresentationName) {
      setPresentationNameDraft(presentationInternalName);
    }
  }, [presentationInternalName, editingPresentationName]);

  const savePresentationInternalName = useCallback(async () => {
    const next = String(presentationNameDraft || "").trim();
    setEditingPresentationName(false);
    if (!id || !next || next === presentationInternalName) return;
    await EditSubTitlesCall({
      id,
      title: next,
      lang: currentLang,
      type: "presentation",
    });
  }, [presentationNameDraft, id, presentationInternalName, currentLang]);

  // Sync local publishStatus from the subtitle's is_published field
  useEffect(() => {
    if (!presentationSubtitle) return;
    const next = presentationSubtitle.is_published ? "published" : "unpublished";
    console.log("[WebPresentations] maker sync publishStatus", {
      presentationId: id,
      is_published: presentationSubtitle.is_published,
      next,
      ownerTypeHint: presentationSubtitle?.type || presentationSubtitle?.parent_id,
    });
    setPublishStatus(next);
  }, [presentationSubtitle, id]);

  const handleUpdatePublishStatus = async (nextStatus) => {
    // Close menu immediately for snappy UI, then sync with backend + Redux.
    setPublishMenuAnchor(null);
    const targetId = id;
    if (!targetId) return;

    const body = {
      title_id: targetId,
      is_published: nextStatus === "published",
    };
    console.log("[WebPresentations] maker publish click", {
      presentationId: targetId,
      nextStatus,
      body,
    });

    const res = await UpdatePresentationPublishCall(body);
    console.log("[WebPresentations] maker publish done", res);
    // Refresh presentation titles so is_published is updated in Redux.
    await GetTitlesCall(currentLang, "presentation");
    // publishStatus will be updated by the useEffect that watches presentationTitle.
  };

  useEffect(() => subscribePresentationImageSource((next) => {
    setImageSource(next);
    setPreferOwnImagesState(getPreferOwnImages());
  }), []);

  const fetchUploads = useCallback(async () => {
    try {
      setUploadsLoading(true);
      // Only this user's presentation library, not slide or system files they also own.
      const list = await GetMyUploadsCall("user_upload");
      const persisted = getPersistedUploads();
      const byUrl = new Map();
      persisted.forEach((item) => byUrl.set(item.url, item));
      (list || []).forEach((item) => byUrl.set(item.url, item));
      const merged = Array.from(byUrl.values());
      // When API returns empty, still show persisted so refresh keeps showing sessionStorage uploads
      setUploads((prev) =>
        merged.length > 0 ? merged : (persisted.length > 0 ? persisted : prev)
      );
    } catch (error) {
      console.error("Error loading uploads:", error);
      const persisted = getPersistedUploads();
      if (persisted.length > 0) setUploads(persisted);
    } finally {
      setUploadsLoading(false);
    }
  }, []);

  useEffect(() => {
    const onAdded = (event) => {
      const item = event?.detail;
      if (!item?.url) return;
      setUploads((prev) => {
        if (prev.some((file) => file.url === item.url)) return prev;
        const next = [...prev, item];
        persistUploads(next);
        return next;
      });
    };
    window.addEventListener("microlab:user-upload-added", onAdded);
    return () => window.removeEventListener("microlab:user-upload-added", onAdded);
  }, []);

  const handleUploadsFileChange = async (event) => {
    const file = event?.target?.files?.[0];
    if (!file) return;
    setUploadsUploading(true);
    try {
      const isImage = String(file.type || "").startsWith("image/") || /\.(png|jpe?g|webp|gif)$/i.test(file.name);
      const uploaded = isImage
        ? await UploadMyFileRecordCall(file, "user_upload")
        : { url: await UploadMyFileCall(file, "user_upload"), id: null };
      const url = uploaded?.url;
      if (url) {
        const item = {
          id: uploaded.id || `local-${Date.now()}`,
          url,
          name: file.name,
          alias: file.name,
          type: file.type || (isImage ? "image/png" : "video/mp4"),
        };
        setUploads((prev) => {
          const next = [...prev, item];
          persistUploads(next);
          return next;
        });
        if (isImage && uploaded.id) {
          setImageReview({ phase: "generating", fileId: uploaded.id, url, name: file.name, draft: "" });
          const described = await DescribeMyPresentationImageCall({
            file_id: uploaded.id,
            url,
            context: presentationInternalName,
          });
          const asset = described?.data;
          if (asset) {
            setImageLibrary((prev) => [asset, ...prev.filter((item) => item.id !== asset.id)]);
          }
          setImageReview(
            asset
              ? {
                  phase: "ready",
                  id: asset.id,
                  fileId: uploaded.id,
                  url,
                  name: file.name,
                  draft: asset.suggested_description || "",
                  subject: asset.subject || "",
                  structure: asset.structure || "",
                  tags: asset.tags || "",
                  visibility: "private",
                }
              : { phase: "error", fileId: uploaded.id, url, name: file.name, message: described?.message }
          );
        }
        fetchUploads();
      }
    } catch (error) {
      console.error("Upload failed:", error);
    } finally {
      setUploadsUploading(false);
      if (uploadsInputRef.current) {
        uploadsInputRef.current.value = "";
      }
    }
  };

  const handleImportPowerPoint = async (file) => {
    if (!file || !hasValidId || pptImportingRef.current) return;
    pptImportingRef.current = true;
    const slideIsEmpty = (slide) => {
      const data = slide?.content?.data;
      return !Array.isArray(data) || data.length === 0;
    };
    setPptImport({
      error: "",
      label: t("pages.presentationMaker.importPowerPointReading"),
      done: 0,
      total: 0,
    });
    try {
      const university = store.getState()?.auth?.universityInfo;
      const parsed = await parsePptxFile(file, {
        onFont: allowCanvasFont,
        uploadImage: async (blob, name) => {
          const uploaded = await UploadMyFileRecordCall(
            new File([blob], name, { type: blob.type || "image/png" }),
            "user_upload"
          );
          return uploaded?.url || null;
        },
        onProgress: (info) => {
          if (info.phase !== "slide") return;
          setPptImport({
            error: "",
            done: info.done,
            total: info.total,
            label: t("pages.presentationMaker.importingPowerPoint", {
              current: info.done + 1,
              total: info.total,
            }),
          });
        },
      });
      const existing = store.getState().uni?.slides ?? [];
      const onlyEmpty = existing.length === 1 && slideIsEmpty(existing[0]);
      let firstIndex = existing.length;
      for (let i = 0; i < parsed.slides.length; i += 1) {
        const imported = parsed.slides[i];
        setPptImport({
          error: "",
          done: i,
          total: parsed.slides.length,
          label: t("pages.presentationMaker.importingPowerPoint", {
            current: i + 1,
            total: parsed.slides.length,
          }),
        });
        let slideId = null;
        let contentId = null;
        if (i === 0 && onlyEmpty) {
          slideId = existing[0].id;
          contentId = existing[0].presentation_content_id || null;
          firstIndex = 0;
          await CallAPI({
            url: getAddSlidePresentationURL,
            method: "PUT",
            body: { id: slideId, title: imported.title },
          });
        } else {
          const created = await CallAPI({
            url: getAddSlidePresentationURL,
            method: "POST",
            body: {
              title_id: id,
              title: imported.title || String(i + 1),
              university_id: university?.university_id,
            },
          });
          slideId = created?.data?.id;
          if (!slideId) throw new Error(created?.message || "slide");
        }
        const saved = contentId
          ? await EditContentToSlidePresentationCall({
              content_id: contentId,
              data: imported.elements,
            })
          : await AddContentToSlidePresentationCall({
              slide_id: slideId,
              data: imported.elements,
            });
        if (saved?.status >= 400) throw new Error(saved?.message || "content");
      }
      await GetAllSlideWithContentByTitleId(id);
      const nextSlides = store.getState().uni?.slides ?? [];
      dispatch(setCurrentSlide(nextSlides[firstIndex] || nextSlides[0] || null));
      fetchUploads();
      setPptImport(
        parsed.skippedMedia
          ? {
              error: "",
              label: "",
              note: t("pages.presentationMaker.importPowerPointSkipped", {
                count: parsed.skippedMedia,
              }),
              done: parsed.slides.length,
              total: parsed.slides.length,
            }
          : null
      );
    } catch (error) {
      const code = error?.code || (error instanceof PptxImportError ? error.code : "");
      setPptImport({
        error:
          code === "legacy-ppt"
            ? t("pages.presentationMaker.importPowerPointLegacy")
            : code === "empty"
              ? t("pages.presentationMaker.importPowerPointEmpty")
              : t("pages.presentationMaker.importPowerPointFailed"),
        label: "",
        done: 0,
        total: 0,
      });
    } finally {
      pptImportingRef.current = false;
      if (pptxInputRef.current) pptxInputRef.current.value = "";
    }
  };

  const filteredUploads = useMemo(() => {
    const q = uploadsSearch.trim().toLowerCase();
    let list = uploads;
    if (uploadsTab === "images") {
      list = list.filter((f) => f.type?.startsWith("image/"));
    } else if (uploadsTab === "videos") {
      list = list.filter((f) => f.type?.startsWith("video/"));
    } else {
      list = list.filter(
        (f) => f.type?.startsWith("image/") || f.type?.startsWith("video/")
      );
    }
    if (!q) return list;
    return list.filter((f) => {
      const caption = imageLibrary.find((item) => item.file_id === f.id);
      const name = (f.alias || f.name || "").toLowerCase();
      const meta = `${caption?.title || ""} ${caption?.description || ""} ${caption?.suggested_description || ""} ${caption?.tags || ""} ${caption?.structure || ""} ${caption?.subject || ""}`.toLowerCase();
      return name.includes(q) || meta.includes(q);
    });
  }, [uploads, uploadsSearch, uploadsTab, imageLibrary]);

  useEffect(() => {
    hasEnsuredSlideRef.current = false;
    setInitialLoadDone(false);
  }, [id]);

  useEffect(() => {
    if (!hasValidId) return;
    let cancelled = false;
    GetAllSlideWithContentByTitleId(id).then(() => {
      if (cancelled) return;
      const slides = store.getState().uni?.slides ?? [];
      const current = store.getState().uni?.currentSlide;
      const match =
        (Array.isArray(slides) &&
          slides.find((slide) => String(slide?.id) === String(current?.id))) ||
        slides[0] ||
        null;
      dispatch(setCurrentSlide(match));
      setInitialLoadDone(true);
    });
    return () => { cancelled = true; };
  }, [dispatch, hasValidId, id]);

  // AI assistant may append slides while this page is open — reload on confirm.
  useEffect(() => {
    if (!hasValidId) return undefined;
    const onReload = (event) => {
      const targetId = event?.detail?.id;
      if (targetId && String(targetId) !== String(id)) return;
      GetAllSlideWithContentByTitleId(id).then(() => {
        const slides = store.getState().uni?.slides ?? [];
        const current = store.getState().uni?.currentSlide;
        const match =
          (Array.isArray(slides) &&
            slides.find((slide) => String(slide?.id) === String(current?.id))) ||
          slides[0] ||
          null;
        dispatch(setCurrentSlide(match));
      });
    };
    window.addEventListener("microlab:presentation-reload", onReload);
    return () => window.removeEventListener("microlab:presentation-reload", onReload);
  }, [dispatch, hasValidId, id]);

  useEffect(() => {
    if (!hasValidId || !initialLoadDone || hasEnsuredSlideRef.current) return;
    if (!allSlides || allSlides.length > 0) return;
    hasEnsuredSlideRef.current = true;
    const university = store.getState()?.auth?.universityInfo;
    AddSlideToPresentationCall({
      id,
      title_id: id,
      title: 1,
      university_id: university?.university_id,
    });
  }, [id, hasValidId, initialLoadDone, allSlides]);

  useEffect(() => {
    if (hasValidId) return;
    navigate("/presentationTitles", { replace: true });
  }, [hasValidId, navigate]);

  useEffect(() => {
    latestCanvasSnapshotRef.current = cloneCanvasData(initialCanvasData);
  }, [cloneCanvasData, initialCanvasData]);

  const waitForRenderFrame = useCallback(
    () =>
      new Promise((resolve) => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            window.setTimeout(resolve, 350);
          });
        });
      }),
    []
  );

  const thumbChainRef = useRef(Promise.resolve());
  const generateThumbnailForSlide = useCallback(
    (slideId, canvasData) => {
      const run = async () => {
        try {
          // Use the same off-screen export stage as PDF export so we capture
          // the slide content reliably (edit stage has iframes/video html2canvas can't capture).
          setExportSlidePayload(Array.isArray(canvasData) ? canvasData : []);
          setExportSlideKey(`thumb-${slideId}-${Date.now()}`);
          await waitForRenderFrame();
          if (!exportStageRef.current) return;
          const canvas = await html2canvas(exportStageRef.current, {
            backgroundColor: "#ffffff",
            scale: 0.25,
            useCORS: true,
            allowTaint: true,
            logging: false,
          });
          const thumbnail = canvas.toDataURL("image/png");
          setExportSlidePayload(null);
          const latestSlides = store.getState().uni?.slides ?? [];
          const updated = latestSlides.map((slide) =>
            slide?.id === slideId ? { ...slide, thumbnail } : slide
          );
          dispatch(setSlides(updated));
        } catch (error) {
          console.error("Thumbnail capture failed:", error);
          setExportSlidePayload(null);
        }
      };
      const job = thumbChainRef.current.then(run, run);
      thumbChainRef.current = job.then(
        () => undefined,
        () => undefined
      );
      return job;
    },
    [dispatch, waitForRenderFrame]
  );

  const handleSaveSlide = async (slideMeta, canvasData) => {
    const slideId = slideMeta?.id;
    const presentationContentId = slideMeta?.presentation_content_id;
    if (!slideId || !hasValidId) return;

    // Avoid unnecessary PUT/POST on first load or when nothing actually changed.
    const latestSlidesBeforeSave = store.getState().uni?.slides ?? [];
    const existingSlide = latestSlidesBeforeSave.find((s) => s?.id === slideId);
    const prevData = existingSlide?.content?.data;
    try {
      const nextJson = JSON.stringify(Array.isArray(canvasData) ? canvasData : []);
      const prevJson = JSON.stringify(Array.isArray(prevData) ? prevData : []);
      if (nextJson === prevJson && presentationContentId) {
        // Content is identical to what we already have persisted – skip API call.
        return;
      }
    } catch (e) {
      // If comparison fails for any reason, fall through and save normally.
    }
    const saveRequestId = latestSaveRequestRef.current + 1;
    latestSaveRequestRef.current = saveRequestId;
    latestCanvasSnapshotRef.current = cloneCanvasData(canvasData);

    // Apply locally first so editor and presenter stay in sync immediately.
    dispatch(updateSlideContentById({ slideId, data: canvasData }));

    try {
      if (presentationContentId) {
        await EditContentToSlidePresentationCall({
          content_id: presentationContentId,
          data: canvasData,
        });
      } else {
        await AddContentToSlidePresentationCall({
          slide_id: slideId,
          data: canvasData,
        });
      }
      // Ignore stale completions from older save requests.
      if (saveRequestId !== latestSaveRequestRef.current) {
        return;
      }
      generateThumbnailForSlide(slideId, canvasData);
    } catch (error) {
      console.error("Error saving slide content:", error);
    }
  };

  const handleSlideSelect = (slide) => {
    dispatch(setCurrentSlide(slide));
  };

  const generatedThumbnailIdsRef = useRef(new Set());
  const slideIdsKey = (allSlides ?? []).map((slide) => slide?.id ?? "").join(",");
  // Capture every slide once the deck loads, so the strip is filled without
  // opening each page. Live previews cover the gap until each capture finishes.
  useEffect(() => {
    let cancelled = false;
    const timer = window.setTimeout(() => {
      const slides = store.getState().uni?.slides ?? [];
      const pending = slides.filter((slide) => {
        if (!slide?.id || slide.thumbnail || generatedThumbnailIdsRef.current.has(slide.id)) {
          return false;
        }
        const data = slide?.content?.data;
        return Array.isArray(data) && data.length > 0;
      });
      const capture = async () => {
        for (const slide of pending) {
          if (cancelled) return;
          generatedThumbnailIdsRef.current.add(slide.id);
          await generateThumbnailForSlide(slide.id, slide.content.data);
        }
      };
      capture();
    }, 700);
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [slideIdsKey, generateThumbnailForSlide]);

  const handleDeleteSlide = async (slide) => {
    if (!hasValidId || !slide?.id) return;
    const confirmed = await openAppConfirm({
      title: t("pages.presentationMaker.deleteSlideConfirm"),
      message: t("pages.presentationMaker.deleteSlideConfirm"),
      confirmText: "Delete",
      confirmColor: "error",
    });
    if (!confirmed) return;
    const deletedId = slide.id;
    const res = await DeletePresentationSlideCall(slide.id, id);
    if (res?.status === 200 || res?.status === 201) {
      if (currentSlide?.id === deletedId) {
        const updatedSlides = store.getState().uni?.slides ?? [];
        dispatch(setCurrentSlide(updatedSlides[0] ?? null));
      }
    }
  };

  const onMousePlus = useCallback(async () => {
    if (!hasValidId) return;
    const university = store.getState()?.auth?.universityInfo;
    const body = {
      id,
      title_id: id,
      title: 1,
      university_id: university?.university_id,
    };
    AddSlideToPresentationCall(body);
  }, [hasValidId, id]);

  const [isPlayMode, setIsPlayMode] = useState(false);
  const [playSlideIndex, setPlaySlideIndex] = useState(0);
  const slideBeforePlayIdRef = useRef(null);
  const [playSnapshotData, setPlaySnapshotData] = useState(null);
  const [playSnapshotSlideId, setPlaySnapshotSlideId] = useState(null);
  const [playSlidesSnapshot, setPlaySlidesSnapshot] = useState([]);


  const liveCurrentData = useMemo(() => {
    const fresh = (allSlides ?? []).find((s) => s?.id === currentSlide?.id);
    const data = fresh?.content?.data ?? currentSlide?.content?.data;
    return Array.isArray(data) ? data : [];
  }, [allSlides, currentSlide]);
  const currentDesign = useMemo(() => getSlideDesign(liveCurrentData), [liveCurrentData]);
  const currentTheme = getTheme(currentDesign.themeId);

  const addTextPreset = useCallback((preset) => {
    const presets = {
      textbox: {
        dimension: { width: "360px", height: "80px" },
        position: { left: 120, top: 120 },
        content:
          '<p><span style="font-size: 28px; font-family: Segoe UI, Arial, sans-serif; color: rgb(15, 23, 42);">Add a text box</span></p>',
      },
      heading: {
        dimension: { width: "720px", height: "110px" },
        position: { left: 110, top: 90 },
        content:
          '<p><strong style="font-size: 58px; font-family: Segoe UI, Arial, sans-serif; color: rgb(15, 23, 42);">Add a heading</strong></p>',
      },
      subheading: {
        dimension: { width: "620px", height: "84px" },
        position: { left: 120, top: 220 },
        content:
          '<p><strong style="font-size: 34px; font-family: Segoe UI, Arial, sans-serif; color: rgb(30, 41, 59);">Add a subheading</strong></p>',
      },
      body: {
        dimension: { width: "560px", height: "72px" },
        position: { left: 120, top: 330 },
        content:
          '<p><span style="font-size: 24px; font-family: Segoe UI, Arial, sans-serif; color: rgb(71, 85, 105);">Add a little bit of body text</span></p>',
      },
    };
    const nextPreset = presets[preset];
    if (!nextPreset) return;
    // With a theme on the slide, new text uses the theme's type and layout.
    if (currentTheme && preset !== "textbox") {
      const role = preset === "heading" ? "heading" : preset === "subheading" ? "subheading" : "body";
      const layout = currentTheme.layouts?.content?.[role === "subheading" ? "body" : role];
      const label =
        role === "heading" ? "Add a heading" : role === "subheading" ? "Add a subheading" : "Add a little bit of body text";
      ensureThemeFonts(currentTheme);
      toolbarActionsRef.current?.addElement?.("TEXT", {
        ...nextPreset,
        content: themedTextHtml(currentTheme, role, label),
        ...(layout
          ? {
              position: { left: layout.left, top: role === "subheading" ? layout.top - 8 : layout.top },
              dimension: { width: `${layout.width}px`, height: nextPreset.dimension.height },
            }
          : null),
      });
      return;
    }
    toolbarActionsRef.current?.addElement?.("TEXT", nextPreset);
  }, [currentTheme]);

  const toolGroups = useMemo(
    () => [
      {
        key: "design",
        labelKey: "pages.presentationMaker.design",
        label: "Design",
        icon: <AutoAwesomeOutlinedIcon />,
        onClick: () => setStudioOpen((prev) => !prev),
      },
      {
        key: "uploads",
        dividerBefore: true,
        labelKey: "pages.presentationMaker.uploads",
        icon: <CloudUploadOutlinedIcon />,
        onClick: () => setActivePanel((prev) => (prev === "uploads" ? null : "uploads")),
      },
      {
        key: "imageSources",
        labelKey: "pages.presentationMaker.imageSources",
        icon: <ImageIcon />,
        onClick: () => setActivePanel((prev) => (prev === "imageSources" ? null : "imageSources")),
      },
      {
        key: "text",
        dividerBefore: true,
        labelKey: "pages.presentationMaker.text",
        icon: <TextFieldsOutlinedIcon />,
        onClick: () => setActivePanel((prev) => (prev === "text" ? null : "text")),
      },
      {
        key: "image",
        labelKey: "pages.presentationMaker.image",
        icon: <AddPhotoAlternateOutlinedIcon />,
        onClick: () => {
          setActivePanel(null);
          toolbarActionsRef.current?.addElement?.("IMAGE");
        },
      },
      {
        key: "video",
        labelKey: "pages.presentationMaker.video",
        icon: <VideoLibraryOutlinedIcon />,
        onClick: () => {
          setActivePanel(null);
          toolbarActionsRef.current?.addElement?.("VIDEO");
        },
      },
      {
        key: "slide",
        labelKey: "pages.presentationMaker.slide",
        icon: <SlideshowOutlinedIcon />,
        onClick: () => {
          setActivePanel(null);
          toolbarActionsRef.current?.addElement?.("SLIDE");
        },
      },
      {
        key: "model",
        labelKey: "pages.presentationMaker.model3d",
        icon: <ThreeDRotationOutlinedIcon />,
        onClick: () => {
          setActivePanel(null);
          toolbarActionsRef.current?.addElement?.("3D_MODEL");
        },
      },
    ],
    []
  );

  const currentSlideIndex = Math.max(
    0,
    allSlides?.findIndex?.((slide) => slide?.id === currentSlide?.id) ?? 0
  );


  useEffect(() => {
    const updateScale = () => {
      const stageNode = stageAreaRef.current;
      if (!stageNode) return;
      const isWebStage = viewMode !== "mobile";
      const availableWidth = Math.max(stageNode.clientWidth - (isWebStage ? 0 : 24), 280);
      const availableHeight = Math.max(stageNode.clientHeight - (isWebStage ? 0 : 24), 200);
      let maxEditScale = isWebStage ? 1.85 : 1.2;
      if (isWebStage && window.innerWidth <= 1440) maxEditScale = 1.55;
      if (isWebStage && window.innerWidth <= 1280) maxEditScale = 1.32;
      if (isWebStage && window.innerWidth <= 1180) maxEditScale = 1.18;
      const maxScaleBySize = Math.min(
        (isWebStage ? 2400 : MAX_STAGE_DISPLAY_WIDTH) / editStageFrameW,
        (isWebStage ? 1320 : MAX_STAGE_DISPLAY_HEIGHT) / editStageFrameH
      );
      // Fit the stage inside the available area so margins stay even.
      const fitScale = Math.min(
        availableWidth / editStageFrameW,
        availableHeight / editStageFrameH,
        maxEditScale,
        maxScaleBySize
      );
      setEditScale(Math.max(0.35, fitScale));
    };
    updateScale();
    const observer =
      typeof ResizeObserver !== "undefined" && stageAreaRef.current
        ? new ResizeObserver(updateScale)
        : null;
    if (observer && stageAreaRef.current) {
      observer.observe(stageAreaRef.current);
    }
    window.addEventListener("resize", updateScale);
    return () => {
      window.removeEventListener("resize", updateScale);
      observer?.disconnect();
    };
  }, [activePanel, viewMode, editStageFrameW, editStageFrameH]);

  // Load uploads once when uploads panel is opened; seed from sessionStorage so refresh keeps list
  const rememberImageAsset = useCallback((asset) => {
    if (!asset?.id) return;
    setImageLibrary((prev) => [asset, ...prev.filter((item) => item.id !== asset.id)]);
  }, []);

  const openImageCaption = useCallback(async (file) => {
    if (!file?.id || String(file.id).startsWith("local-")) return;
    const existing = imageLibrary.find((item) => item.file_id === file.id);
    const name = file.alias || file.name || "Image";
    if (existing && (existing.description || existing.suggested_description)) {
      setImageReview({
        phase: "ready",
        id: existing.id,
        fileId: file.id,
        url: file.url,
        name,
        draft: existing.status === "confirmed"
          ? existing.description
          : existing.suggested_description || existing.description || "",
        subject: existing.subject || "",
        structure: existing.structure || "",
        tags: existing.tags || "",
        visibility: existing.scope === "public" ? "public" : "private",
      });
      return;
    }
    setImageReview({ phase: "generating", fileId: file.id, url: file.url, name, draft: "" });
    const described = await DescribeMyPresentationImageCall({
      file_id: file.id,
      url: file.url,
      context: presentationInternalName,
    });
    const asset = described?.data;
    if (asset) rememberImageAsset(asset);
    setImageReview(
      asset
        ? {
            phase: "ready",
            id: asset.id,
            fileId: file.id,
            url: file.url,
            name,
            draft: asset.suggested_description || asset.description || "",
            subject: asset.subject || "",
            structure: asset.structure || "",
            tags: asset.tags || "",
            visibility: "private",
          }
        : {
            phase: "error",
            fileId: file.id,
            url: file.url,
            name,
            message: described?.message,
          }
    );
  }, [imageLibrary, presentationInternalName, rememberImageAsset]);

  useEffect(() => {
    if (activePanel !== "uploads") return;
    const persisted = getPersistedUploads();
    if (persisted.length > 0) setUploads((prev) => (prev.length === 0 ? persisted : prev));
    fetchUploads();
    let cancelled = false;
    GetMyPresentationImagesCall().then((res) => {
      if (!cancelled && Array.isArray(res?.data)) setImageLibrary(res.data);
    });
    return () => {
      cancelled = true;
    };
  }, [activePanel, fetchUploads]);

  const startPlayMode = useCallback((options = {}) => {
    if (!allSlides?.length) return;
    const targetSlideId = options.slideId ?? currentSlide?.id ?? null;
    const targetSlideIndex =
      typeof options.slideIndex === "number"
        ? Math.max(0, Math.min(options.slideIndex, allSlides.length - 1))
        : currentSlideIndex;
    const liveCanvasData = cloneCanvasData(
      options.canvasData ??
        toolbarActionsRef.current?.getCanvasData?.() ??
        latestCanvasSnapshotRef.current
    );
    const snapshotSlides = (allSlides ?? []).map((slide) => {
      const slideData = cloneCanvasData(slide?.content?.data);
      if (
        slide?.id &&
        targetSlideId &&
        slide.id === targetSlideId &&
        Array.isArray(liveCanvasData)
      ) {
        return {
          ...slide,
          content: { ...(slide.content || {}), data: liveCanvasData },
        };
      }
      return {
        ...slide,
        content: slide?.content ? { ...slide.content, data: slideData } : slide?.content,
      };
    });
    setPlaySlidesSnapshot(snapshotSlides);
    if (Array.isArray(liveCanvasData) && targetSlideId) {
      dispatch(updateSlideContentById({ slideId: targetSlideId, data: liveCanvasData }));
      setPlaySnapshotData(liveCanvasData);
      setPlaySnapshotSlideId(targetSlideId);
    } else {
      setPlaySnapshotData(null);
      setPlaySnapshotSlideId(null);
    }
    slideBeforePlayIdRef.current = targetSlideId;
    setIsPlayMode(true);
    setPlaySlideIndex(targetSlideIndex);
  }, [allSlides, cloneCanvasData, currentSlide, currentSlideIndex, dispatch]);

  const requestRefreshBeforePlay = useCallback(() => {
    if (!allSlides?.length || !hasValidId) return;
    const liveCanvasData = cloneCanvasData(
      toolbarActionsRef.current?.getCanvasData?.() ?? latestCanvasSnapshotRef.current
    );
    try {
      sessionStorage.setItem(
        PRESENTATION_RELOAD_KEY,
        JSON.stringify({
          presentationId: id,
          slideId: currentSlide?.id ?? null,
          slideIndex: currentSlideIndex,
          canvasData: Array.isArray(liveCanvasData) ? liveCanvasData : [],
        })
      );
    } catch (error) {
      startPlayMode();
      return;
    }
    window.location.reload();
  }, [allSlides?.length, cloneCanvasData, currentSlide?.id, currentSlideIndex, hasValidId, id, startPlayMode]);

  // Lift Present-reload payload out of sessionStorage immediately so a slow
  // slide load cannot leave the flag set and refresh the tab forever.
  const pendingPlayAfterReloadRef = useRef(null);
  useEffect(() => {
    try {
      const rawPayload = sessionStorage.getItem(PRESENTATION_RELOAD_KEY);
      if (!rawPayload) return;
      const payload = JSON.parse(rawPayload);
      sessionStorage.removeItem(PRESENTATION_RELOAD_KEY);
      if (payload?.presentationId === id) {
        pendingPlayAfterReloadRef.current = payload;
      }
    } catch (error) {
      try {
        sessionStorage.removeItem(PRESENTATION_RELOAD_KEY);
      } catch (removeError) {}
    }
  }, [id]);

  useEffect(() => {
    if (!hasValidId || !initialLoadDone || !allSlides?.length) return;
    const payload = pendingPlayAfterReloadRef.current;
    if (!payload) return;
    pendingPlayAfterReloadRef.current = null;
    startPlayMode({
      slideId: payload?.slideId ?? null,
      slideIndex: typeof payload?.slideIndex === "number" ? payload.slideIndex : 0,
      canvasData: payload?.canvasData,
    });
  }, [allSlides?.length, hasValidId, id, initialLoadDone, startPlayMode]);

  const exitPlayMode = useCallback(() => {
    setIsPlayMode(false);
    setPlaySnapshotData(null);
    setPlaySnapshotSlideId(null);
    setPlaySlidesSnapshot([]);
    const restoreSlideId = slideBeforePlayIdRef.current;
    if (restoreSlideId) {
      const latestSlides = store.getState().uni?.slides ?? [];
      const latestSlide = latestSlides.find((slide) => slide?.id === restoreSlideId) ?? null;
      dispatch(setCurrentSlide(latestSlide));
    }
    slideBeforePlayIdRef.current = null;
  }, [dispatch]);

  // Keyboard, click and touch navigation in play mode live in CinematicPlayer.


  const playSlidesSource = isPlayMode && playSlidesSnapshot.length ? playSlidesSnapshot : allSlides;
  const scaledEditWidth = (EDIT_STAGE_WIDTH + FRAME_BORDER_SIZE) * editScale;
  const scaledEditHeight = (EDIT_STAGE_HEIGHT + FRAME_BORDER_SIZE) * editScale;
  const brandLogoSrc =
    university?.logo_url || require("../../assets/images/logos/mini_logo.png");

  const handleExportPresentation = useCallback(() => {
    const payload = {
      id,
      exported_at: new Date().toISOString(),
      slides: allSlides ?? [],
    };
    const blob = new Blob([JSON.stringify(payload, null, 2)], {
      type: "application/json",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `presentation-${id || "export"}.json`;
    link.click();
    window.URL.revokeObjectURL(url);
    setFileMenuAnchor(null);
  }, [allSlides, id]);

  const getSlidesForExport = useCallback(() => {
    const liveCanvasData = cloneCanvasData(
      toolbarActionsRef.current?.getCanvasData?.() ?? latestCanvasSnapshotRef.current
    );
    return (allSlides ?? []).map((slide) => {
      const slideData =
        slide?.id && currentSlide?.id && slide.id === currentSlide.id
          ? liveCanvasData
          : cloneCanvasData(slide?.content?.data);
      return {
        ...slide,
        content: {
          ...(slide?.content || {}),
          data: Array.isArray(slideData) ? slideData : [],
        },
      };
    });
  }, [allSlides, cloneCanvasData, currentSlide?.id]);

  const captureSlideImage = useCallback(
    async (slide, index) => {
      const slideData = Array.isArray(slide?.content?.data) ? slide.content.data : [];
      setExportSlidePayload(slideData);
      setExportSlideKey(`${slide?.id ?? "slide"}-${index}-${Date.now()}`);
      await waitForRenderFrame();
      if (!exportStageRef.current) {
        throw new Error("Export stage is not ready");
      }
      const canvas = await html2canvas(exportStageRef.current, {
        backgroundColor: null,
        scale: 2,
        useCORS: true,
        allowTaint: true,
        logging: false,
      });
      return canvas.toDataURL("image/png");
    },
    [waitForRenderFrame]
  );

  const handleExportPdf = useCallback(async () => {
    if (!allSlides?.length || isExporting) return;
    setFileMenuAnchor(null);
    setIsExporting(true);
    try {
      const slides = getSlidesForExport();
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "px",
        format: [EXPORT_STAGE_WIDTH, EXPORT_STAGE_HEIGHT],
      });

      for (let index = 0; index < slides.length; index += 1) {
        const imageData = await captureSlideImage(slides[index], index);
        if (index > 0) {
          pdf.addPage([EXPORT_STAGE_WIDTH, EXPORT_STAGE_HEIGHT], "landscape");
        }
        pdf.addImage(imageData, "PNG", 0, 0, EXPORT_STAGE_WIDTH, EXPORT_STAGE_HEIGHT);
      }

      pdf.save(`presentation-${id || "export"}.pdf`);
    } catch (error) {
      console.error("PDF export failed:", error);
    } finally {
      setIsExporting(false);
      setExportSlidePayload(null);
    }
  }, [
    EXPORT_STAGE_HEIGHT,
    EXPORT_STAGE_WIDTH,
    allSlides?.length,
    captureSlideImage,
    getSlidesForExport,
    id,
    isExporting,
  ]);

  const handleExportPowerPoint = useCallback(async () => {
    if (!allSlides?.length || isExporting) return;
    setFileMenuAnchor(null);
    setIsExporting(true);
    try {
      const PptxGenJS = await loadPptxGenJS();
      const slides = getSlidesForExport();
      const pptx = new PptxGenJS();
      pptx.defineLayout({
        name: "MICROLAB_PRESENTATION",
        width: 13.08,
        height: 7.48,
      });
      pptx.layout = "MICROLAB_PRESENTATION";
      pptx.author = "Microlab";
      pptx.subject = "Presentation export";
      pptx.title = `presentation-${id || "export"}`;

      for (let index = 0; index < slides.length; index += 1) {
        const imageData = await captureSlideImage(slides[index], index);
        const pptSlide = pptx.addSlide();
        pptSlide.background = { color: "FFFFFF" };
        pptSlide.addImage({
          data: imageData,
          x: 0,
          y: 0,
          w: 13.08,
          h: 7.48,
        });
      }

      await pptx.writeFile({ fileName: `presentation-${id || "export"}.pptx` });
    } catch (error) {
      console.error("PowerPoint export failed:", error);
    } finally {
      setIsExporting(false);
      setExportSlidePayload(null);
    }
  }, [allSlides?.length, captureSlideImage, getSlidesForExport, id, isExporting]);


  /* ---------------------- Cinematic design studio ---------------------- */

  const previousSlideData = useMemo(() => {
    const prev = currentSlideIndex > 0 ? allSlides?.[currentSlideIndex - 1] : null;
    return Array.isArray(prev?.content?.data) ? prev.content.data : null;
  }, [allSlides, currentSlideIndex]);

  const uploadedImages = useMemo(
    () =>
      (uploads || []).filter(
        (u) => String(u?.type || "").startsWith("image/") || /\.(png|jpe?g|webp|gif|svg)(\?|$)/i.test(u?.url || "")
      ),
    [uploads]
  );

  useEffect(() => {
    if (studioOpen && studioTab === "background" && !uploads.length) fetchUploads();
  }, [studioOpen, studioTab]);

  useEffect(() => {
    if (!designToast) return undefined;
    const timer = window.setTimeout(() => setDesignToast(null), 5000);
    return () => window.clearTimeout(timer);
  }, [designToast]);

  /** Write new canvas data for several slides (live canvas, store, API, thumbnails). */
  const persistSlidesData = useCallback(
    async (updates) => {
      const latestSlides = store.getState().uni?.slides ?? [];
      const currentId = store.getState().uni?.currentSlide?.id;
      const currentUpdate = updates.find((u) => u.slideId === currentId);
      const actions = toolbarActionsRef.current;
      if (currentUpdate && actions?.setCanvasData) {
        // One canvas undo step, so Ctrl+Z also reverts design changes on this slide.
        actions.beginHistoryStep?.();
        actions.setCanvasData(currentUpdate.data);
        actions.endHistoryStep?.();
        latestCanvasSnapshotRef.current = cloneCanvasData(currentUpdate.data);
      }
      await Promise.all(
        updates.map(async ({ slideId, data }) => {
          const slide = latestSlides.find((s) => s?.id === slideId);
          if (!slide) return;
          dispatch(updateSlideContentById({ slideId, data }));
          try {
            if (slide.presentation_content_id) {
              await EditContentToSlidePresentationCall({
                content_id: slide.presentation_content_id,
                data,
              });
            } else {
              await AddContentToSlidePresentationCall({ slide_id: slideId, data });
            }
            generateThumbnailForSlide(slideId, data);
          } catch (error) {
            console.error("Failed to save slide design", slideId, error);
          }
        })
      );
    },
    [cloneCanvasData, dispatch, generateThumbnailForSlide]
  );

  const resolveScopeIndices = useCallback(
    (scope, count) => {
      if (scope === "all") return Array.from({ length: count }, (_, i) => i);
      if (Array.isArray(scope)) return scope.filter((i) => i >= 0 && i < count);
      if (scope && Array.isArray(scope.slides)) {
        return scope.slides.map((n) => n - 1).filter((i) => i >= 0 && i < count);
      }
      return [currentSlideIndex];
    },
    [currentSlideIndex]
  );

  /** Apply a design change to a set of slides with deck-level undo. Returns the slide count. */
  const runDeckOperation = useCallback(
    async (label, scope, mapFn) => {
      const slides = getSlidesForExport();
      const indices = resolveScopeIndices(scope, slides.length);
      const targets = indices.map((i) => ({ slide: slides[i], index: i })).filter((t) => t.slide?.id);
      if (!targets.length) return 0;
      const before = targets.map(({ slide }) => ({
        slideId: slide.id,
        data: cloneCanvasData(slide.content?.data),
      }));
      const after = targets.map(({ slide, index }) => ({
        slideId: slide.id,
        data: mapFn(cloneCanvasData(slide.content?.data), slide, index),
      }));
      deckUndoRef.current.push({ label, before, after });
      if (deckUndoRef.current.length > 30) deckUndoRef.current.shift();
      deckRedoRef.current = [];
      setDeckHistoryVersion((v) => v + 1);
      await persistSlidesData(after);
      setDesignToast({ id: Date.now(), label: `${label} · ${plural(targets.length, "slide")}` });
      return targets.length;
    },
    [cloneCanvasData, getSlidesForExport, persistSlidesData, resolveScopeIndices]
  );

  const undoDeckOperation = useCallback(async () => {
    const entry = deckUndoRef.current.pop();
    if (!entry) return null;
    deckRedoRef.current.push(entry);
    setDeckHistoryVersion((v) => v + 1);
    await persistSlidesData(entry.before);
    setDesignToast({ id: Date.now(), label: `Undid ${entry.label}`, done: true });
    return entry.label;
  }, [persistSlidesData]);

  const redoDeckOperation = useCallback(async () => {
    const entry = deckRedoRef.current.pop();
    if (!entry) return null;
    deckUndoRef.current.push(entry);
    setDeckHistoryVersion((v) => v + 1);
    await persistSlidesData(entry.after);
    setDesignToast({ id: Date.now(), label: `Redid ${entry.label}`, done: true });
    return entry.label;
  }, [persistSlidesData]);

  const applyThemeToSlides = useCallback(
    (themeId, scope, { restyleText = true } = {}) => {
      const theme = getTheme(themeId);
      if (!theme) return Promise.resolve(0);
      ensureThemeFonts(theme);
      return runDeckOperation(`${theme.name} theme`, scope, (data) => {
        // transition: null → slides follow the theme's default transition.
        let next = withSlideDesign(stripLegacyBackground(data), {
          themeId,
          background: { ...theme.background },
          transition: null,
        });
        if (restyleText) {
          next = next.map((el) =>
            el?.type === "TEXT" && typeof el.content === "string"
              ? { ...el, content: restyleTextHtml(el.content, theme) }
              : el
          );
        }
        return next;
      });
    },
    [runDeckOperation]
  );

  const applyStudioBackground = useCallback(
    (background, scope) =>
      runDeckOperation(background ? "Background" : "Removed background", scope, (data) =>
        withSlideDesign(background ? stripLegacyBackground(data) : data, {
          background: background ? JSON.parse(JSON.stringify(background)) : null,
        })
      ),
    [runDeckOperation]
  );

  const applyStudioTransition = useCallback(
    (transition, scope) => {
      const label = TRANSITIONS.find((x) => x.id === transition?.type)?.label || "Transition";
      return runDeckOperation(
        transition?.type === "none" ? "Transitions off" : `${label} transition`,
        scope,
        (data) => withSlideDesign(data, { transition: { ...transition } })
      );
    },
    [runDeckOperation]
  );

  const updateCurrentElements = useCallback((updates) => {
    const actions = toolbarActionsRef.current;
    if (!actions || !updates?.length) return;
    actions.beginHistoryStep?.();
    updates.forEach(({ id: elementId, patch }) => actions.updateCanvasData({ id: elementId, ...patch }));
    actions.endHistoryStep?.();
    actions.saveNow?.();
  }, []);

  const selectCanvasElement = useCallback((elementId) => {
    toolbarActionsRef.current?.setActiveSelection?.(new Set([elementId]));
  }, []);

  const stopCanvasPreviewRef = useRef(null);
  const previewCanvasAnimations = useCallback(() => {
    stopCanvasPreviewRef.current?.();
    const data = toolbarActionsRef.current?.getCanvasData?.() || liveCurrentData;
    stopCanvasPreviewRef.current = previewAnimationsOnCanvas(editStageFrameRef.current, data);
  }, [liveCurrentData]);
  useEffect(() => () => stopCanvasPreviewRef.current?.(), []);

  const uploadBackgroundImage = useCallback(async (file) => {
    try {
      const uploaded = await UploadMyFileRecordCall(file, "user_upload");
      const url = uploaded?.url;
      if (url) {
        setUploads((prev) => {
          const next = [
            ...prev,
            {
              id: uploaded.id || `local-${Date.now()}`,
              url,
              name: file.name,
              alias: file.name,
              type: file.type || "image/png",
            },
          ];
          persistUploads(next);
          return next;
        });
      }
      return url || null;
    } catch (error) {
      console.error("Background upload failed:", error);
      return null;
    }
  }, []);

  const animateCurrentSlide = useCallback(
    async ({ target, effect, trigger }) => {
      const data = toolbarActionsRef.current?.getCanvasData?.() || liveCurrentData;
      const targets = pickAnimationTargets(data, target);
      const histologyWithLabels =
        target === "labels"
          ? getRenderableElements(data).filter(
              (el) => el.type === "SLIDE" && el.slideAnnotations?.features?.length
            )
          : [];
      if (!targets.length && !histologyWithLabels.length) {
        return `I couldn't find ${target === "all" ? "elements" : target} to animate on this slide.`;
      }
      const order = new Map(targets.map((el, i) => [el.id, i]));
      await runDeckOperation("Animations", "current", (slideData) =>
        slideData.map((el) => {
          if (histologyWithLabels.some((h) => h.id === el?.id)) {
            return { ...el, annotationReveal: "progressive" };
          }
          if (!order.has(el?.id)) return el;
          const i = order.get(el.id);
          return {
            ...el,
            animation: {
              effect,
              trigger: trigger === "after" && i === 0 ? "enter" : trigger,
              delay: 0,
              duration: 600,
              order: i,
            },
          };
        })
      );
      const parts = [];
      if (targets.length) {
        parts.push(
          `${plural(targets.length, target === "labels" ? "label" : "element")} now ${
            trigger === "click" ? "appear one per click" : "build in sequence"
          }`
        );
      }
      if (histologyWithLabels.length) parts.push("histology pins are revealed one by one");
      return `On this slide, ${parts.join(" and ")}.`;
    },
    [liveCurrentData, runDeckOperation]
  );

  const createMorphZoom = useCallback(async () => {
    const slides = getSlidesForExport();
    if (slides.length < 2) return "Morph needs two slides. Add a second slide first.";
    const toIdx = currentSlideIndex > 0 ? currentSlideIndex : 1;
    const fromIdx = toIdx - 1;
    const fromData = slides[fromIdx]?.content?.data || [];
    const toData = slides[toIdx]?.content?.data || [];
    const pairs = matchMorphElements(fromData, toData);
    const fromViewer = getRenderableElements(fromData).find((el) => el.type === "SLIDE");
    const toViewer = getRenderableElements(toData).find((el) => el.type === "SLIDE");
    // Pair the two histology viewers explicitly when nothing else links them.
    const key =
      fromViewer && toViewer && !pairs.some((p) => p.to.id === toViewer.id)
        ? fromViewer.morphKey || `morph-${Date.now()}`
        : null;
    await runDeckOperation("Morph zoom", [fromIdx, toIdx], (data, slide, index) => {
      let next = data;
      if (key) {
        next = next.map((el) =>
          (index === fromIdx && el?.id === fromViewer.id) || (index === toIdx && el?.id === toViewer.id)
            ? { ...el, morphKey: key }
            : el
        );
      }
      if (index === toIdx) {
        next = withSlideDesign(next, { transition: { type: "morph", duration: 1000, easing: "cinematic" } });
      }
      return next;
    });
    const matched = pairs.length + (key ? 1 : 0);
    if (!matched) {
      return `Slide ${toIdx + 1} now uses Morph, but it shares nothing with slide ${fromIdx + 1} yet. Put the same histology slide or image on both and it will glide between them.`;
    }
    return `Slide ${fromIdx + 1} → ${toIdx + 1} now morphs: ${plural(matched, "element")} glide into place${
      fromViewer && toViewer ? ", including the histology view" : ""
    }. Present to see it.`;
  }, [currentSlideIndex, getSlidesForExport, runDeckOperation]);

  const handleDesignRequest = useCallback(
    async (text) => {
      const { ops, unknown } = parseDesignRequest(text);
      if (unknown) {
        return {
          text:
            "I can restyle this presentation: themes, backgrounds, transitions, element animations and morph zooms. Try “Apply a cinematic medical theme” or “Add smooth transitions to all slides”.",
        };
      }
      const changes = [];
      for (const op of ops) {
        if (op.kind === "undo") {
          const label = await undoDeckOperation();
          changes.push(label ? `Undid ${label}` : "There's no design change to undo");
        } else if (op.kind === "redo") {
          const label = await redoDeckOperation();
          changes.push(label ? `Redid ${label}` : "There's nothing to redo");
        } else if (op.kind === "preview") {
          startPlayMode();
          changes.push("Started the presentation from this slide (Esc to return)");
        } else if (op.kind === "theme") {
          const n = await applyThemeToSlides(op.themeId, op.scope);
          changes.push(`Applied the ${getTheme(op.themeId)?.name} theme to ${plural(n, "slide")}`);
        } else if (op.kind === "transition") {
          const base = currentDesign.transition || currentTheme?.transition || DEFAULT_TRANSITION;
          const spec = {
            type: op.type,
            duration: op.duration ?? base.duration,
            easing: op.easing ?? base.easing,
          };
          const n = await applyStudioTransition(spec, op.scope);
          const label = TRANSITIONS.find((x) => x.id === op.type)?.label || op.type;
          changes.push(
            op.type === "none"
              ? `Turned transitions off on ${plural(n, "slide")}`
              : `${label} transition (${spec.duration} ms) on ${plural(n, "slide")}`
          );
        } else if (op.kind === "background") {
          const n = await applyStudioBackground(op.background, op.scope);
          const name =
            op.background.kind === "preset"
              ? getBackgroundPreset(op.background.presetId)?.label
              : op.background.color;
          changes.push(`${name} background on ${plural(n, "slide")}`);
        } else if (op.kind === "animate") {
          changes.push(await animateCurrentSlide(op));
        } else if (op.kind === "clearAnimations") {
          await runDeckOperation("Removed animations", "current", (data) =>
            data.map((el) => (el?.animation ? { ...el, animation: null } : el))
          );
          changes.push("Removed the animations on this slide");
        } else if (op.kind === "morph") {
          changes.push(await createMorphZoom());
        }
      }
      return {
        text: changes.length === 1 ? changes[0] : `Done: ${changes.join("; ")}.`,
      };
    },
    [
      animateCurrentSlide,
      applyStudioBackground,
      applyStudioTransition,
      applyThemeToSlides,
      createMorphZoom,
      currentDesign.transition,
      currentTheme,
      redoDeckOperation,
      runDeckOperation,
      startPlayMode,
      undoDeckOperation,
    ]
  );

  // Requests typed in the Microlab Assistant chat while this editor is open.
  const designRequestRef = useRef(handleDesignRequest);
  designRequestRef.current = handleDesignRequest;
  useEffect(() => {
    const onDesignRequest = (event) => {
      const detail = event?.detail;
      if (!detail?.text || typeof detail.respond !== "function") return;
      Promise.resolve(designRequestRef.current(detail.text))
        .then((reply) => detail.respond({ text: reply?.text, options: DESIGN_CHAT_OPTIONS }))
        .catch(() => detail.respond({ text: "I couldn't apply that design change. Please try again." }));
    };
    window.addEventListener(PRESENTATION_DESIGN_EVENT, onDesignRequest);
    return () => window.removeEventListener(PRESENTATION_DESIGN_EVENT, onDesignRequest);
  }, []);

  const playerSlides = useMemo(() => {
    if (!isPlayMode) return [];
    return (playSlidesSource ?? []).map((slide) =>
      slide?.id && slide.id === playSnapshotSlideId && Array.isArray(playSnapshotData)
        ? { ...slide, content: { ...(slide.content || {}), data: playSnapshotData } }
        : slide
    );
  }, [isPlayMode, playSlidesSource, playSnapshotData, playSnapshotSlideId]);

  const imageReviewCard = !imageReview ? null : (
                  <Box
                                        sx={{
                      mb: 1.5,
                      p: 1.25,
                      borderRadius: 2.5,
                      bgcolor: "background.elevated",
                      border: (t) => `1px solid ${t.palette.line.main}`,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
                      {imageReview.url ? (
                        <Box
                          component="img"
                          src={imageReview.url}
                          alt=""
                          sx={{ width: 54, height: 40, objectFit: "cover", borderRadius: 1.5, flexShrink: 0 }}
                        />
                      ) : null}
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        {imageReview.phase === "analyzing" || imageReview.phase === "generating" ? (
                          <Box sx={{ color: "#64748b", fontSize: 13 }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <CircularProgress size={14} />
                              <span>
                                {imageReview.phase === "analyzing"
                                  ? t("pages.presentationImages.analyzing")
                                  : imageReview.name && !imageReview.fileId
                                    ? t("pages.presentationImages.generatingImage")
                                    : t("pages.presentationImages.generating")}
                              </span>
                              {imageReview.phase === "generating" && !imageReview.fileId ? (
                                <Box component="span" sx={{ ml: "auto", fontWeight: 700, color: "#0369a1" }}>
                                  {Math.round(imageProgress)}%
                                </Box>
                              ) : null}
                            </Box>
                            {imageReview.phase === "generating" && !imageReview.fileId ? (
                              <LinearProgress
                                variant="determinate"
                                value={imageProgress}
                                aria-label={t("pages.presentationImages.generatingImage")}
                                sx={{
                                  mt: 1,
                                  height: 6,
                                  borderRadius: 999,
                                  bgcolor: "#e2e8f0",
                                  "& .MuiLinearProgress-bar": {
                                    borderRadius: 999,
                                    bgcolor: "#0284c7",
                                  },
                                }}
                              />
                            ) : null}
                          </Box>
                        ) : null}
                        {imageReview.phase === "saving" ? (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "#64748b", fontSize: 13 }}>
                            <CircularProgress size={14} />
                            <span>{t("pages.presentationImages.saving")}</span>
                          </Box>
                        ) : null}
                      </Box>
                      <IconButton
                        size="small"
                        aria-label={t("pages.presentationImages.later")}
                        onClick={() => setImageReview(null)}
                        sx={{ mt: -0.5 }}
                      >
                        <CloseRoundedIcon sx={{ fontSize: 16, color: "#94a3b8" }} />
                      </IconButton>
                    </Box>
                    {imageReview.phase === "ready" ? (
                      <>
                        <Typography sx={{ mt: 1, mb: 0.6, fontSize: 12, fontWeight: 700, color: "ink.body" }}>
                          {t("pages.presentationImages.suggested")}
                        </Typography>
                        <TextField
                          fullWidth
                          multiline
                          minRows={2}
                          size="small"
                          value={imageReview.draft}
                          onChange={(event) =>
                            setImageReview((prev) => ({ ...prev, draft: event.target.value }))
                          }
                          sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "background.card", fontSize: 13 } }}
                        />
                        <TextField
                          fullWidth
                          size="small"
                          placeholder={t("pages.presentationImages.structure")}
                          value={imageReview.structure || ""}
                          onChange={(event) =>
                            setImageReview((prev) => ({ ...prev, structure: event.target.value }))
                          }
                          sx={{ mt: 1, "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "background.card", fontSize: 12 } }}
                        />
                        {userRole === "admin" ? (
                          <TextField
                            select
                            size="small"
                            value={imageReview.visibility || "private"}
                            onChange={(event) =>
                              setImageReview((prev) => ({ ...prev, visibility: event.target.value }))
                            }
                            SelectProps={{ native: true }}
                            sx={{ mt: 1, "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "background.card", fontSize: 12 } }}
                          >
                            <option value="private">{t("pages.presentationImages.privateStatus")}</option>
                            <option value="public">{t("pages.presentationImages.publicStatus")}</option>
                          </TextField>
                        ) : null}
                        <Typography sx={{ mt: 0.6, fontSize: 11.5, lineHeight: 1.4, color: "#94a3b8" }}>
                          {t("pages.presentationImages.needsConfirm")}
                        </Typography>
                        <Box sx={{ mt: 1, display: "flex", gap: 0.5 }}>
                          <MDButton
                            variant="contained"
                            color="info"
                            disabled={imageReview.draft.trim().length < 8}
                            onClick={async () => {
                              setImageReview((prev) => ({ ...prev, phase: "saving" }));
                              const res = await ConfirmMyPresentationImageCall(imageReview.id, {
                                description: imageReview.draft,
                                subject: imageReview.subject,
                                structure: imageReview.structure,
                                tags: imageReview.tags,
                                visibility: userRole === "admin" ? imageReview.visibility || "private" : "private",
                              });
                              if (res?.data) {
                                rememberImageAsset(res.data);
                                setImageReview(null);
                              } else {
                                setImageReview((prev) => ({ ...prev, phase: "ready", message: res?.message }));
                              }
                            }}
                            sx={{ textTransform: "none", borderRadius: 999, boxShadow: "none", fontSize: 12 }}
                          >
                            {t("pages.presentationImages.confirm")}
                          </MDButton>
                          <MDButton
                            variant="text"
                            color="info"
                            onClick={async () => {
                              setImageReview((prev) => ({ ...prev, phase: "generating" }));
                              const res = await RegenerateMyPresentationImageCall(imageReview.id, {
                                context: presentationInternalName,
                              });
                              if (res?.data) rememberImageAsset(res.data);
                              setImageReview((prev) => ({
                                ...prev,
                                phase: "ready",
                                draft: res?.data?.suggested_description || prev?.draft || "",
                                subject: res?.data?.subject || prev?.subject || "",
                                structure: res?.data?.structure || prev?.structure || "",
                                tags: res?.data?.tags || prev?.tags || "",
                              }));
                            }}
                            sx={{ textTransform: "none", fontSize: 12 }}
                          >
                            {t("pages.presentationImages.regenerate")}
                          </MDButton>
                        </Box>
                      </>
                    ) : null}
                    {imageReview.phase === "error" ? (
                      <MDButton
                        variant="text"
                        color="info"
                        onClick={() =>
                          openImageCaption({
                            id: imageReview.fileId,
                            url: imageReview.url,
                            name: imageReview.name,
                          })
                        }
                        sx={{ mt: 0.5, textTransform: "none", fontSize: 12 }}
                      >
                        {t("pages.presentationImages.regenerate")}
                      </MDButton>
                    ) : null}
                    {imageReview.message ? (
                      <Typography sx={{ mt: 0.75, fontSize: 12, color: "#e11d48" }}>
                        {imageReview.message}
                      </Typography>
                    ) : null}
                  </Box>
  );

  if (!hasValidId) {
    return null;
  }

  return (
    <DashboardLayout>
      <Box
        className={`content presentation-maker-root${isDark ? " is-dark" : ""}`}
        sx={{
          p: 0,
          bgcolor: isDark ? "#10131c" : "#eef1f6",
        }}
      >
        {!isPlayMode && (
          <>
            <Box className="presentation-maker-topbar">
              <Box display="flex" alignItems="center" gap={1} sx={{ minWidth: 0, flex: 1 }}>
                <IconButton
                  size="small"
                  onClick={() => navigate("/presentationTitles")}
                  aria-label={t("pages.presentationMaker.backToPresentations")}
                  sx={{ color: "white", opacity: 0.92 }}
                >
                  <ArrowBackIcon fontSize="small" />
                </IconButton>
                <Box
                  component="img"
                  src={brandLogoSrc}
                  alt={university?.name || "Microlab"}
                  className="presentation-maker-brand"
                />
                {editingPresentationName ? (
                  <TextField
                    size="small"
                    value={presentationNameDraft}
                    autoFocus
                    onChange={(e) => setPresentationNameDraft(e.target.value)}
                    onBlur={savePresentationInternalName}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        savePresentationInternalName();
                      }
                      if (e.key === "Escape") {
                        setEditingPresentationName(false);
                        setPresentationNameDraft(presentationInternalName);
                      }
                    }}
                    sx={{
                      minWidth: 160,
                      maxWidth: 280,
                      "& .MuiOutlinedInput-root": {
                        bgcolor: "rgba(255,255,255,0.14)",
                        color: "white",
                        fontWeight: 650,
                        fontSize: "0.9rem",
                        "& fieldset": { borderColor: "rgba(255,255,255,0.28)" },
                        "&:hover fieldset": { borderColor: "rgba(255,255,255,0.45)" },
                        "&.Mui-focused fieldset": { borderColor: "rgba(255,255,255,0.7)" },
                      },
                      "& .MuiInputBase-input": { py: 0.6, px: 1.1 },
                    }}
                  />
                ) : (
                  <Box
                    className="presentation-maker-title"
                    onClick={() => {
                      setPresentationNameDraft(presentationInternalName);
                      setEditingPresentationName(true);
                    }}
                    title={t("pages.presentationMaker.renamePresentation")}
                    sx={{
                      cursor: "text",
                      maxWidth: 260,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      px: 1,
                      py: 0.5,
                      borderRadius: 1.5,
                      "&:hover": { bgcolor: "rgba(255,255,255,0.12)" },
                    }}
                  >
                    {presentationInternalName}
                  </Box>
                )}
                <MDButton
                  variant="text"
                  onClick={(event) => setFileMenuAnchor(event.currentTarget)}
                  sx={{
                    color: "white !important",
                    textTransform: "none",
                    fontWeight: 650,
                    fontSize: "0.85rem",
                    minWidth: "auto",
                    px: 1,
                  }}
                >
                  {t("pages.presentationMaker.file")}
                </MDButton>
                <MDButton
                  variant="text"
                  onClick={(event) => setPublishMenuAnchor(event.currentTarget)}
                  sx={{
                    color: "white !important",
                    textTransform: "none",
                    fontWeight: 650,
                    fontSize: "0.85rem",
                    minWidth: "auto",
                    px: 1.25,
                    borderRadius: 999,
                    backgroundColor:
                      publishStatus === "published"
                        ? "rgba(16,185,129,0.18)"
                        : "rgba(15,23,42,0.18)",
                    "&:hover": {
                      backgroundColor:
                        publishStatus === "published"
                          ? "rgba(16,185,129,0.28)"
                          : "rgba(15,23,42,0.28)",
                    },
                  }}
                >
                  {t("pages.presentationMaker.publish")}
                </MDButton>
              </Box>

              <Box
                display="flex"
                alignItems="center"
                gap={0.25}
                sx={{
                  display: { xs: "none", md: "flex" },
                  height: 32,
                  px: 0.5,
                  borderRadius: 999,
                  bgcolor: "rgba(15,23,42,0.28)",
                  boxSizing: "border-box",
                }}
              >
                <IconButton
                  size="small"
                  onClick={() => toolbarActionsRef.current?.undo?.()}
                  sx={{ color: "white", width: 28, height: 28 }}
                  aria-label={t("pages.presentationMaker.undo")}
                >
                  <UndoOutlinedIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => toolbarActionsRef.current?.redo?.()}
                  sx={{ color: "white", width: 28, height: 28 }}
                  aria-label={t("pages.presentationMaker.redo")}
                >
                  <RedoOutlinedIcon fontSize="small" />
                </IconButton>
              </Box>

              <Box className="presentation-maker-topbar-right">
                <Box className="presentation-view-toggle" role="group" aria-label="View mode">
                  {[
                    { key: "web", label: "Web" },
                    { key: "mobile", label: "Mobile" },
                  ].map((mode) => {
                    const active = viewMode === mode.key;
                    return (
                      <button
                        key={mode.key}
                        type="button"
                        className={`presentation-view-toggle-btn${active ? " is-active" : ""}`}
                        onClick={() => setViewMode(mode.key)}
                        aria-pressed={active}
                      >
                        {mode.label}
                      </button>
                    );
                  })}
                </Box>
                <MDButton
                  variant="text"
                  startIcon={<AutoAwesomeOutlinedIcon sx={{ fontSize: 16 }} />}
                  onClick={() => setStudioOpen((open) => !open)}
                  aria-pressed={studioOpen}
                  sx={{
                    color: "white !important",
                    textTransform: "none",
                    fontWeight: 650,
                    fontSize: "0.85rem",
                    minWidth: "auto",
                    px: 1.25,
                    borderRadius: 999,
                    backgroundColor: studioOpen ? "rgba(255,255,255,0.18)" : "transparent",
                    "& .MuiButton-startIcon": { marginRight: 0.5, marginLeft: 0 },
                    "&:hover": { backgroundColor: "rgba(255,255,255,0.14)" },
                  }}
                >
                  {t("pages.presentationMaker.design", { defaultValue: "Design" })}
                </MDButton>
                <MDButton
                  variant="text"
                  startIcon={<IosShareOutlinedIcon sx={{ fontSize: 16 }} />}
                  onClick={() => setShareOpen(true)}
                  disabled={!id || id === "undefined"}
                  sx={{
                    color: "white !important",
                    textTransform: "none",
                    fontWeight: 650,
                    fontSize: "0.85rem",
                    minWidth: "auto",
                    px: 1.25,
                    "& .MuiButton-startIcon": { marginRight: 0.5, marginLeft: 0 },
                  }}
                >
                  {t("pages.presentationMaker.share")}
                </MDButton>
                <MDButton
                  className="presentation-present-btn"
                  variant="contained"
                  color="info"
                  startIcon={<PlayArrowIcon sx={{ fontSize: 18 }} />}
                  onClick={requestRefreshBeforePlay}
                  disabled={!allSlides?.length}
                  sx={{
                    textTransform: "none",
                    fontWeight: 700,
                    borderRadius: 999,
                    backgroundColor: "rgba(255,255,255,0.14)",
                    color: "white !important",
                    boxShadow: "none",
                    "& .MuiButton-startIcon": { marginRight: 0.5, marginLeft: 0 },
                    "&:hover": {
                      backgroundColor: "rgba(255,255,255,0.22)",
                      boxShadow: "none",
                    },
                  }}
                >
                  {t("pages.presentationMaker.present")}
                </MDButton>
              </Box>
            </Box>

            <SharePresentationDialog
              open={shareOpen}
              titleId={id}
              onClose={() => setShareOpen(false)}
            />

            <Menu
              anchorEl={fileMenuAnchor}
              open={Boolean(fileMenuAnchor)}
              onClose={() => setFileMenuAnchor(null)}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
              PaperProps={{
                sx: {
                  mt: 1,
                  borderRadius: 3,
                  minWidth: 220,
                  boxShadow: "0 20px 45px rgba(15,23,42,0.18)",
                },
              }}
            >
              {[
                {
                  icon: <DescriptionOutlinedIcon fontSize="small" />,
                  labelKey: "pages.presentationMaker.createNewPresentation",
                  onClick: () => {
                    setFileMenuAnchor(null);
                    navigate("/presentationTitles");
                  },
                },
                {
                  icon: <DriveFileRenameOutlineIcon fontSize="small" />,
                  labelKey: "pages.presentationMaker.renamePresentation",
                  onClick: () => {
                    setFileMenuAnchor(null);
                    setPresentationNameDraft(presentationInternalName);
                    setEditingPresentationName(true);
                  },
                },
                {
                  icon: <UndoOutlinedIcon fontSize="small" />,
                  labelKey: "pages.presentationMaker.undo",
                  hint: "Ctrl+Z",
                  onClick: () => {
                    toolbarActionsRef.current?.undo?.();
                    setFileMenuAnchor(null);
                  },
                },
                {
                  icon: <RedoOutlinedIcon fontSize="small" />,
                  labelKey: "pages.presentationMaker.redo",
                  hint: "Ctrl+Shift+Z",
                  onClick: () => {
                    toolbarActionsRef.current?.redo?.();
                    setFileMenuAnchor(null);
                  },
                },
                {
                  icon: <DownloadOutlinedIcon fontSize="small" />,
                  labelKey: "pages.presentationMaker.exportJson",
                  disabled: isExporting,
                  onClick: handleExportPresentation,
                },
                {
                  icon: <DownloadOutlinedIcon fontSize="small" />,
                  labelKey: "pages.presentationMaker.exportPdf",
                  disabled: isExporting,
                  onClick: handleExportPdf,
                },
                {
                  icon: <DownloadOutlinedIcon fontSize="small" />,
                  labelKey: "pages.presentationMaker.exportPptx",
                  disabled: isExporting,
                  onClick: handleExportPowerPoint,
                },
                {
                  icon: <LogoutOutlinedIcon fontSize="small" />,
                  labelKey: "pages.presentationMaker.exit",
                  onClick: () => {
                    setFileMenuAnchor(null);
                    navigate("/presentationTitles");
                  },
                },
              ].map((item) => (
              <MenuItem
                key={item.labelKey}
                onClick={item.onClick}
                disabled={item.disabled}
                sx={{
                  py: 1,
                  px: 1.5,
                  minHeight: 42,
                  gap: 0.05,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 22,
                    color: "#64748b",
                    "& svg": {
                      fontSize: 18,
                    },
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={t(item.labelKey)}
                  primaryTypographyProps={{
                    fontSize: "0.82rem",
                    fontWeight: 600,
                    color: "#334155",
                    lineHeight: 1.2,
                  }}
                />
                {item.hint && (
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{
                      ml: 2,
                      fontSize: "0.82rem",
                      fontWeight: 600,
                      lineHeight: 1.2,
                      color: "#64748b",
                    }}
                  >
                    {item.hint}
                  </Typography>
                )}
              </MenuItem>
              ))}
            </Menu>
            <Menu
              anchorEl={publishMenuAnchor}
              open={Boolean(publishMenuAnchor)}
              onClose={() => setPublishMenuAnchor(null)}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
              PaperProps={{
                sx: {
                  mt: 1,
                  borderRadius: 3.5,
                  minWidth: 290,
                  p: 1,
                  boxShadow: "0 22px 50px rgba(15,23,42,0.2)",
                  border: "1px solid rgba(148,163,184,0.18)",
                  backdropFilter: "blur(14px)",
                },
              }}
            >
              <MenuItem
                selected={publishStatus === "published"}
                onClick={() => handleUpdatePublishStatus("published")}
                sx={{
                  borderRadius: 2.5,
                  py: 1.25,
                  px: 1.25,
                  mb: 0.5,
                  alignItems: "center",
                  "&.Mui-selected": {
                    backgroundColor: "rgba(16,185,129,0.12)",
                  },
                  "&.Mui-selected:hover": {
                    backgroundColor: "rgba(16,185,129,0.18)",
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: 38, color: "#059669" }}>
                  <PublicOutlinedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary={t("pages.presentationMaker.publishedToStudents")}
                  secondary={t("pages.presentationMaker.publishedToStudentsDesc")}
                  primaryTypographyProps={{ fontWeight: 700, fontSize: "0.95rem" }}
                  secondaryTypographyProps={{ fontSize: "0.8rem", color: "text.secondary" }}
                />
                {publishStatus === "published" && <CheckIcon sx={{ fontSize: 18, color: "#059669" }} />}
              </MenuItem>
              <MenuItem
                selected={publishStatus === "unpublished"}
                onClick={() => handleUpdatePublishStatus("unpublished")}
                sx={{
                  borderRadius: 2.5,
                  py: 1.25,
                  px: 1.25,
                  alignItems: "center",
                  "&.Mui-selected": {
                    backgroundColor: "rgba(100,116,139,0.14)",
                  },
                  "&.Mui-selected:hover": {
                    backgroundColor: "rgba(100,116,139,0.2)",
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: 38, color: "ink.soft" }}>
                  <VisibilityOffOutlinedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary={t("pages.presentationMaker.unpublishedToStudents")}
                  secondary={t("pages.presentationMaker.unpublishedToStudentsDesc")}
                  primaryTypographyProps={{ fontWeight: 700, fontSize: "0.95rem" }}
                  secondaryTypographyProps={{ fontSize: "0.8rem", color: "text.secondary" }}
                />
                {publishStatus === "unpublished" && (
                  <CheckIcon sx={{ fontSize: 18, color: "ink.soft" }} />
                )}
              </MenuItem>
            </Menu>
          </>
        )}

        {!isPlayMode && (
          <Box className="presentation-maker-workspace">
            <Box className="presentation-tools-rail">
              {toolGroups.map((tool) => [
                tool.dividerBefore ? (
                  <Box key={`${tool.key}-divider`} className="presentation-tools-divider" aria-hidden="true" />
                ) : null,
                <Box
                  key={tool.key}
                  role="button"
                  tabIndex={0}
                  aria-pressed={activePanel === tool.key || (tool.key === "design" && studioOpen)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      tool.onClick();
                    }
                  }}
                  className={`presentation-tool-card ${
                    activePanel === tool.key || (tool.key === "design" && studioOpen) ? "selected" : ""
                  }`}
                  onClick={tool.onClick}
                >
                  <Box className="presentation-tool-icon">{tool.icon}</Box>
                  <Typography className="presentation-tool-label" component="span">
                    {tool.label ? t(tool.labelKey, { defaultValue: tool.label }) : t(tool.labelKey)}
                  </Typography>
                </Box>,
              ])}
            </Box>

            <WorkspaceStage>
              <WorkspaceOverlay side="left" open={Boolean(activePanel)} label="Tool panel">
            {activePanel === "text" && (
              <Box className="presentation-side-panel">
                <Typography className="presentation-panel-heading">
                  {t("pages.presentationMaker.defaultTextStyles")}
                </Typography>
                <Box
                  className="presentation-text-preset heading"
                  onClick={() => addTextPreset("heading")}
                >
                  <Typography>{t("pages.presentationMaker.addHeading")}</Typography>
                </Box>
                <Box
                  className="presentation-text-preset subheading"
                  onClick={() => addTextPreset("subheading")}
                >
                  <Typography>{t("pages.presentationMaker.addSubheading")}</Typography>
                </Box>
                <Box
                  className="presentation-text-preset body"
                  onClick={() => addTextPreset("body")}
                >
                  <Typography>{t("pages.presentationMaker.addBodyText")}</Typography>
                </Box>
              </Box>
            )}

            {activePanel === "imageSources" && (
              <Box className="presentation-side-panel">
                <ImageSourcePicker
                  layout="segmented"
                  value={imageSource}
                  preferOwn={preferOwnImages}
                  onChange={(next) => {
                    setImageSource(next);
                    setPresentationImageSource(next);
                  }}
                  onPreferOwnChange={(next) => {
                    setPreferOwnImagesState(next);
                    setPreferOwnImages(next);
                  }}
                />
                <Typography className="presentation-panel-heading">
                  {t("pages.presentationImages.generateTitle")}
                </Typography>
                <Typography sx={{ mt: -0.75, color: "#64748b", fontSize: 12, lineHeight: 1.4 }}>
                  {t("pages.presentationImages.generateHelp")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  multiline
                  minRows={4}
                  placeholder={t("pages.presentationImages.generatePrompt")}
                  value={imagePrompt}
                  onChange={(event) => setImagePrompt(event.target.value)}
                  sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2.5, bgcolor: "background.card", fontSize: 13 } }}
                />
                <MDButton
                  variant="contained"
                  color="info"
                  disabled={imagePrompt.trim().length < 8 || imageReview?.phase === "generating"}
                  onClick={async () => {
                    setImageReview({ phase: "generating", draft: "", name: imagePrompt });
                    const res = await GenerateTeachingImageCall({ prompt: imagePrompt });
                    const asset = res?.data;
                    if (!asset?.url) {
                      setImageReview({ phase: "error", message: res?.message || "Image generation failed.", draft: "" });
                      return;
                    }
                    const item = {
                      id: asset.file_id,
                      url: asset.url,
                      name: asset.title || "AI illustration",
                      alias: asset.title || imagePrompt,
                      type: "image/png",
                    };
                    setUploads((prev) => {
                      const next = [item, ...prev.filter((file) => file.id !== item.id)];
                      persistUploads(next);
                      return next;
                    });
                    setImageLibrary((prev) => [asset, ...prev.filter((entry) => entry.id !== asset.id)]);
                    setImageReview({
                      phase: "ready",
                      id: asset.id,
                      fileId: asset.file_id,
                      url: asset.url,
                      name: item.name,
                      draft: asset.suggested_description || "",
                      subject: asset.subject || "",
                      structure: asset.structure || "",
                      tags: asset.tags || "",
                      visibility: "private",
                    });
                  }}
                  sx={{ textTransform: "none", borderRadius: 999, boxShadow: "none", fontSize: 13, py: 0.9 }}
                >
                  {t("pages.presentationImages.generateAction")}
                </MDButton>
                {imageReviewCard}
              </Box>
            )}

            {activePanel === "uploads" && (
              <Box
                className="presentation-side-panel"
                onDragOver={(event) => event.preventDefault()}
                onDrop={(event) => {
                  event.preventDefault();
                  const file = event.dataTransfer.files?.[0];
                  if (!file) return;
                  if (isPowerPointFile(file)) {
                    handleImportPowerPoint(file);
                    return;
                  }
                  handleUploadsFileChange({ target: { files: [file] } });
                }}
              >
                <Typography className="presentation-panel-heading">
                  {t("pages.presentationMaker.uploads")}
                </Typography>
                <Box mb={1.5}>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder={t("pages.presentationMaker.searchUploads")}
                    value={uploadsSearch}
                    onChange={(event) => setUploadsSearch(event.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon
                            sx={{ fontSize: 18, color: "rgba(148,163,184,0.9)" }}
                          />
                        </InputAdornment>
                      ),
                      sx: {
                        borderRadius: 999,
                        bgcolor: "background.elevated",
                        fontSize: 13,
                      },
                    }}
                  />
                </Box>

                <Box mb={1.5} display="flex" gap={1}>
                  <MDButton
                    variant="gradient"
                    color="info"
                    onClick={() => uploadsInputRef.current?.click()}
                    sx={{
                      flex: 1,
                      borderRadius: 999,
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: 13,
                      px: 1.5,
                      py: 0.5,
                    }}
                  >
                    {uploadsUploading ? t("pages.presentationMaker.uploading") : t("pages.presentationMaker.uploadFiles")}
                  </MDButton>
                  <input
                    ref={uploadsInputRef}
                    type="file"
                    accept="image/*,video/*"
                    style={{ display: "none" }}
                    onChange={handleUploadsFileChange}
                  />
                </Box>
                <MDButton
                  variant="outlined"
                  color="info"
                  disabled={Boolean(pptImport?.label)}
                  onClick={() => pptxInputRef.current?.click()}
                  sx={{
                    width: "100%",
                    borderRadius: 999,
                    textTransform: "none",
                    fontWeight: 700,
                    fontSize: 13,
                    mb: 1,
                  }}
                >
                  {t("pages.presentationMaker.importPowerPoint")}
                </MDButton>
                <input
                  ref={pptxInputRef}
                  type="file"
                  accept=".pptx,.ppt,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-powerpoint"
                  style={{ display: "none" }}
                  onChange={(event) => {
                    const file = event.target.files?.[0];
                    if (file) handleImportPowerPoint(file);
                  }}
                />
                <Typography sx={{ mb: 1.25, color: "#64748b", fontSize: 12, lineHeight: 1.45 }}>
                  {t("pages.presentationMaker.importPowerPointHint")}
                </Typography>
                {pptImport && (pptImport.error || pptImport.label || pptImport.note) && (
                  <Box mb={1.5}>
                    <Typography
                      sx={{
                        fontSize: 12.5,
                        color: pptImport.error ? "#b91c1c" : "#475569",
                        mb: pptImport.label ? 0.75 : 0,
                        lineHeight: 1.45,
                      }}
                    >
                      {pptImport.error || pptImport.label || pptImport.note}
                    </Typography>
                    {pptImport.label && pptImport.total > 0 && (
                      <LinearProgress
                        variant="determinate"
                        value={Math.max(4, Math.round((pptImport.done / pptImport.total) * 100))}
                      />
                    )}
                  </Box>
                )}

                {imageReviewCard}

                <Tabs
                  value={uploadsTab}
                  onChange={(_, v) => setUploadsTab(v)}
                  textColor="primary"
                  indicatorColor="primary"
                  sx={{
                    minHeight: 32,
                    mb: 1.5,
                    "& .MuiTab-root": {
                      minHeight: 32,
                      textTransform: "none",
                      fontSize: 12,
                      fontWeight: 600,
                      paddingInline: 1.2,
                    },
                  }}
                >
                  <Tab
                    value="images"
                    label={
                      <Box display="flex" alignItems="center" gap={0.5}>
                        <ImageIcon sx={{ fontSize: 16 }} />
                        <span>{t("pages.presentationMaker.images")}</span>
                      </Box>
                    }
                  />
                  <Tab
                    value="videos"
                    label={
                      <Box display="flex" alignItems="center" gap={0.5}>
                        <MovieIcon sx={{ fontSize: 16 }} />
                        <span>{t("pages.presentationMaker.videos")}</span>
                      </Box>
                    }
                  />
                </Tabs>

                <Box
                  sx={{
                    flex: 1,
                    overflowY: "auto",
                  }}
                >
                  {uploadsLoading ? (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        py: 4,
                      }}
                    >
                      <CircularProgress size={22} />
                    </Box>
                  ) : filteredUploads.length === 0 ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        py: 4,
                        gap: 0.5,
                        fontSize: 12,
                        color: "#64748b",
                      }}
                    >
                      <span>No uploads yet.</span>
                      <span>Use “Upload files” to add media.</span>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fill, minmax(96px, 1fr))",
                        gap: 1,
                      }}
                    >
                      {filteredUploads.map((file) => {
                        const isImage = file.type?.startsWith("image/");
                        const caption = imageLibrary.find((item) => item.file_id === file.id);
                        return (
                          <Box
                            key={file.id || file.url}
                            sx={{
                              position: "relative",
                              borderRadius: 2,
                              overflow: "hidden",
                              bgcolor: isImage ? "#e5e7eb" : "#020617",
                              cursor: "pointer",
                              border: "1px solid rgba(148,163,184,0.45)",
                            }}
                            onClick={() => {
                              if (isImage) {
                                toolbarActionsRef.current?.addElement?.("IMAGE", {
                                  content: file.url,
                                });
                              } else {
                                toolbarActionsRef.current?.addElement?.("VIDEO", {
                                  content: file.url,
                                });
                              }
                              setTimeout(() => {
                                toolbarActionsRef.current?.saveNow?.();
                              }, 100);
                            }}
                          >
                            <IconButton
                              size="small"
                              sx={{
                                position: "absolute",
                                top: 2,
                                right: 2,
                                zIndex: 2,
                                bgcolor: "rgba(15,23,42,0.86)",
                                color: "#fff",
                                "&:hover": { bgcolor: "rgba(15,23,42,0.98)" },
                              }}
                              onClick={async (event) => {
                                event.stopPropagation();
                                if (!file.id) return;
                                const isLocal = String(file.id).startsWith("local-");
                                if (isLocal) {
                                  setUploads((prev) => {
                                    const next = prev.filter((f) => f.id !== file.id);
                                    persistUploads(next);
                                    return next;
                                  });
                                  return;
                                }
                                const ok = await openAppConfirm({
                                  title: t("pages.presentationMaker.deleteUploadConfirm"),
                                  message: t("pages.presentationMaker.deleteUploadConfirm"),
                                  confirmText: "Delete",
                                  confirmColor: "error",
                                });
                                if (!ok) return;
                                try {
                                  await DeleteMyUploadCall(file.id);
                                  setUploads((prev) => {
                                    const next = prev.filter((f) => f.id !== file.id);
                                    persistUploads(next);
                                    return next;
                                  });
                                  setImageLibrary((prev) => prev.filter((item) => item.file_id !== file.id));
                                } catch (error) {
                                  console.error("Failed to delete upload:", error);
                                }
                              }}
                            >
                              <DeleteOutlineIcon sx={{ fontSize: 14 }} />
                            </IconButton>
                            {isImage ? (
                              <Box
                                sx={{
                                  width: "100%",
                                  height: 80,
                                  backgroundImage: `url(${file.url})`,
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                }}
                              />
                            ) : (
                              <Box
                                sx={{
                                  width: "100%",
                                  height: 80,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#e5e7eb",
                                }}
                              >
                                <MovieIcon sx={{ fontSize: 26 }} />
                              </Box>
                            )}
                            {isImage && file.id && !String(file.id).startsWith("local-") ? (
                              <Box
                                component="button"
                                type="button"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  openImageCaption(file);
                                }}
                                sx={{
                                  position: "absolute",
                                  left: 6,
                                  bottom: 30,
                                  zIndex: 2,
                                  border: "none",
                                  borderRadius: 999,
                                  px: 0.8,
                                  py: 0.25,
                                  fontSize: 10,
                                  fontWeight: 700,
                                  cursor: "pointer",
                                  color: caption?.status === "confirmed" ? "#0f766e" : "#1d4ed8",
                                  bgcolor: "rgba(255,255,255,0.94)",
                                }}
                              >
                                {caption?.origin === "generated" ? `${t("pages.presentationImages.aiBadge")} · ` : ""}
                                {caption?.status === "confirmed"
                                  ? t("pages.presentationImages.ready")
                                  : t("pages.presentationImages.addDescription")}
                              </Box>
                            ) : null}
                            <Box
                              sx={{
                                px: 0.75,
                                py: 0.5,
                                bgcolor: "rgba(15,23,42,0.9)",
                                color: "#f9fafb",
                                fontSize: 10,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {file.alias || file.name}
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                  )}
                </Box>
              </Box>
            )}
              </WorkspaceOverlay>

            <Box className="presentation-stage-area" ref={stageAreaRef}>
              <Box className="presentation-stage-shell">
                <Box
                  className="presentation-stage-scale"
                  sx={{
                    width: scaledEditWidth,
                    height: scaledEditHeight,
                    maxWidth: "100%",
                    maxHeight: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                <Box
                  className="presentation-stage-frame"
                  ref={editStageFrameRef}
                  sx={{
                    width: EDIT_STAGE_WIDTH,
                    height: EDIT_STAGE_HEIGHT,
                    transform: `scale(${editScale})`,
                    transformOrigin: "center center",
                  }}
                >
                    {initialLoadDone && currentSlide ? (
                    <CanvasContainer
                      key={currentSlide?.id ?? "no-slide"}
                      initialData={initialCanvasData}
                      uploadEntity={{ entity_type: "presentation", entity_id: id }}
                      uploadsOnlyFromLibrary
                      onSave={(canvasData) =>
                        handleSaveSlide(
                          {
                            id: currentSlide?.id,
                            presentation_content_id: currentSlide?.presentation_content_id,
                          },
                          canvasData
                        )
                      }
                      stageWidth={EDIT_STAGE_WIDTH}
                      stageHeight={EDIT_STAGE_HEIGHT}
                      stageScale={editScale}
                      clipStage
                      showAddButtons={false}
                      actionsRef={toolbarActionsRef}
                      viewMode={viewMode === "mobile" ? "mobile" : "web"}
                    />
                    ) : null}
                  </Box>
                </Box>
              </Box>
            </Box>
            <WorkspaceOverlay side="right" open={studioOpen} label="Design studio">
              <DesignStudio
                tab={studioTab}
                onTabChange={setStudioTab}
                design={currentDesign}
                themeTransition={currentTheme?.transition}
                currentElements={liveCurrentData}
                previousElements={previousSlideData}
                slideCount={allSlides?.length || 0}
                currentIndex={currentSlideIndex}
                uploadedImages={uploadedImages}
                classicBackgrounds={classicBackgrounds}
                classicColors={backgroundColorOptions}
                canUndo={deckUndoRef.current.length > 0}
                canRedo={deckRedoRef.current.length > 0}
                onUndo={undoDeckOperation}
                onRedo={redoDeckOperation}
                onApplyTheme={applyThemeToSlides}
                onApplyBackground={applyStudioBackground}
                onApplyTransition={applyStudioTransition}
                onUpdateElements={updateCurrentElements}
                onSelectElement={selectCanvasElement}
                onPreviewAnimations={previewCanvasAnimations}
                onPresentHere={() => startPlayMode()}
                onUploadImage={uploadBackgroundImage}
                onDesignRequest={handleDesignRequest}
              />
            </WorkspaceOverlay>
            </WorkspaceStage>
          </Box>
        )}

        {!isPlayMode && (
          <Box className="presentation-bottom-strip">
            <Box
              className="presentation-add-thumb"
              onClick={onMousePlus}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onMousePlus();
                }
              }}
            >
              <span className="presentation-add-thumb-icon">
                <AddIcon sx={{ fontSize: 18 }} />
              </span>
              <span>Add page</span>
            </Box>

            <Box className="presentation-thumbs-scroll">
              {(allSlides ?? []).map((slide, index) => {
                const isSelected = slide?.id === currentSlide?.id;
                const slideId = slide?.id ?? index;
                const isDragging = draggedSlideId === slideId;
                const thumbElements = getSlideElements(slide);
                return (
                  <Box
                    key={slideId}
                    className={`presentation-thumb ${isSelected ? "selected" : ""} ${
                      isDragging ? "dragging" : ""
                    }`}
                    onClick={() => handleSlideSelect(slide)}
                    draggable
                    role="button"
                    tabIndex={0}
                    aria-label={`Slide ${index + 1}`}
                    aria-current={isSelected ? "true" : undefined}
                    title={`Slide ${index + 1}`}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        handleSlideSelect(slide);
                      }
                    }}
                    onDragStart={(event) => {
                      event.dataTransfer.effectAllowed = "move";
                      setDraggedSlideId(slideId);
                    }}
                    onDragOver={(event) => {
                      event.preventDefault();
                    }}
                    onDrop={(event) => {
                      event.preventDefault();
                      if (!draggedSlideId) return;
                      const latestSlides = store.getState().uni?.slides ?? [];
                      if (!latestSlides.length) return;
                      const fromIndex = latestSlides.findIndex(
                        (s, i) => (s?.id ?? i) === draggedSlideId
                      );
                      if (fromIndex < 0 || fromIndex === index) return;
                      const reordered = [...latestSlides];
                      const [moved] = reordered.splice(fromIndex, 1);
                      reordered.splice(index, 0, moved);
                      dispatch(setSlides(reordered));
                      setDraggedSlideId(null);
                    }}
                    onDragEnd={() => {
                      setDraggedSlideId(null);
                    }}
                  >
                    <Box className="presentation-thumb-canvas">
                      {slide?.thumbnail ? (
                        <Box
                          sx={{
                            position: "absolute",
                            inset: 0,
                            backgroundImage: `url(${slide.thumbnail})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        />
                      ) : thumbElements.length > 0 ? (
                        <SlideMiniPreview elements={thumbElements} />
                      ) : null}
                    </Box>
                    <Box className="presentation-thumb-number">{index + 1}</Box>
                    <IconButton
                      size="small"
                      className="presentation-thumb-delete"
                      aria-label={`Delete slide ${index + 1}`}
                      onClick={(event) => {
                        event.stopPropagation();
                        handleDeleteSlide(slide);
                      }}
                    >
                      <CloseRoundedIcon sx={{ fontSize: 13 }} />
                    </IconButton>
                  </Box>
                );
              })}
            </Box>

            <Box className="presentation-strip-status" aria-live="polite">
              <span className="presentation-strip-count">
                <strong>{(currentSlideIndex ?? 0) + 1}</strong>
                <span className="presentation-strip-sep">/</span>
                <span>{allSlides?.length || 0}</span>
              </span>
            </Box>
          </Box>
        )}

        {isPlayMode && playerSlides.length > 0 && (
          <CinematicPlayer
            slides={playerSlides}
            startIndex={playSlideIndex}
            stageWidth={PLAY_STAGE_WIDTH}
            stageHeight={PLAY_STAGE_HEIGHT}
            onExit={exitPlayMode}
          />
        )}
        {designToast && !isPlayMode ? (
          <div className="cine-toast" role="status" key={designToast.id}>
            <span>{designToast.label}</span>
            {!designToast.done && deckUndoRef.current.length ? (
              <button type="button" onClick={undoDeckOperation}>
                Undo
              </button>
            ) : null}
          </div>
        ) : null}
        <Box
          sx={{
            position: "fixed",
            left: -20000,
            top: 0,
            width: EXPORT_STAGE_WIDTH,
            height: EXPORT_STAGE_HEIGHT,
            pointerEvents: "none",
            opacity: 0,
            overflow: "hidden",
            zIndex: -1,
          }}
        >
          <Box
            ref={exportStageRef}
            className="presentation-stage-frame presentation-stage-frame-play"
            sx={{
              width: PLAY_STAGE_WIDTH,
              height: PLAY_STAGE_HEIGHT,
            }}
          >
            <CanvasContainer
              key={exportSlideKey}
              initialData={Array.isArray(exportSlidePayload) ? exportSlidePayload : []}
              isPlayMode
              stillBackdrop
              stageWidth={PLAY_STAGE_WIDTH}
              stageHeight={PLAY_STAGE_HEIGHT}
            />
          </Box>
        </Box>
      </Box>
    </DashboardLayout>
  );
}

export default PresentationMakerPage;
